var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228, _rect229, _rect230, _rect231, _rect232, _rect233, _rect234, _rect235, _rect236, _rect237, _rect238, _rect239, _rect240, _rect241, _rect242, _rect243, _rect244, _rect245, _rect246, _rect247, _rect248, _rect249, _rect250, _rect251, _rect252, _rect253, _rect254, _rect255, _rect256, _rect257, _rect258, _rect259, _rect260, _rect261, _rect262, _rect263, _rect264, _rect265, _rect266, _rect267, _rect268, _rect269, _rect270, _rect271, _rect272, _rect273, _rect274, _rect275, _rect276, _rect277, _rect278, _rect279, _rect280, _rect281, _rect282, _rect283, _rect284, _rect285, _rect286, _rect287, _rect288, _rect289, _rect290, _rect291, _rect292, _rect293, _rect294, _rect295, _rect296, _rect297, _rect298, _rect299, _rect300, _rect301, _rect302, _rect303, _rect304, _rect305, _rect306, _rect307, _rect308, _rect309, _rect310, _rect311, _rect312, _rect313, _rect314, _rect315, _rect316, _rect317, _rect318, _rect319, _rect320, _rect321, _rect322, _rect323, _rect324, _rect325, _rect326, _rect327, _rect328, _rect329, _rect330, _rect331, _rect332, _rect333, _rect334, _rect335, _rect336, _rect337, _rect338, _rect339, _rect340, _rect341, _rect342, _rect343, _rect344, _rect345, _rect346, _rect347, _rect348, _rect349, _rect350, _rect351, _rect352, _rect353, _rect354, _rect355, _rect356, _rect357, _rect358, _rect359, _rect360, _rect361, _rect362, _rect363, _rect364, _rect365, _rect366, _rect367, _rect368, _rect369, _rect370, _rect371, _rect372, _rect373, _rect374, _rect375, _rect376, _rect377, _rect378, _rect379, _rect380, _rect381, _rect382, _rect383, _rect384, _rect385, _rect386, _rect387, _rect388, _rect389, _rect390, _rect391, _rect392, _rect393, _rect394, _rect395, _rect396, _rect397, _rect398, _rect399, _rect400, _rect401, _rect402, _rect403, _rect404, _rect405, _rect406, _rect407, _rect408, _rect409, _rect410, _rect411, _rect412, _rect413, _rect414, _rect415, _rect416, _rect417, _rect418, _rect419, _rect420, _rect421, _rect422, _rect423, _rect424, _rect425, _rect426, _rect427, _rect428, _rect429, _rect430, _rect431, _rect432, _rect433, _rect434, _rect435, _rect436, _rect437, _rect438, _rect439, _rect440, _rect441, _rect442, _rect443, _rect444, _rect445, _rect446, _rect447, _rect448, _rect449, _rect450, _rect451, _rect452, _rect453, _rect454, _rect455, _rect456, _rect457, _rect458, _rect459, _rect460, _rect461, _rect462, _rect463, _rect464, _rect465, _rect466, _rect467, _rect468, _rect469, _rect470, _rect471, _rect472, _rect473, _rect474, _rect475, _rect476, _rect477, _rect478, _rect479, _rect480, _rect481, _rect482, _rect483, _rect484, _rect485, _rect486, _rect487, _rect488, _rect489, _rect490, _rect491, _rect492, _rect493, _rect494, _rect495, _rect496, _rect497, _rect498, _rect499, _rect500, _rect501, _rect502, _rect503, _rect504, _rect505, _rect506, _rect507, _rect508, _rect509, _rect510, _rect511, _rect512, _rect513, _rect514, _rect515, _rect516, _rect517, _rect518, _rect519, _rect520, _rect521, _rect522, _rect523, _rect524, _rect525, _rect526, _rect527, _rect528, _rect529, _rect530, _rect531, _rect532, _rect533, _rect534, _rect535, _rect536, _rect537, _rect538, _rect539, _rect540, _rect541, _rect542, _rect543, _rect544, _rect545, _rect546, _rect547, _rect548, _rect549, _rect550, _rect551, _rect552, _rect553, _rect554, _rect555, _rect556, _rect557, _rect558, _rect559, _rect560, _rect561, _rect562, _rect563, _rect564, _rect565, _rect566, _rect567, _rect568, _rect569, _rect570, _rect571, _rect572, _rect573, _rect574, _rect575, _rect576, _rect577, _rect578, _rect579, _rect580, _rect581, _rect582, _rect583, _rect584, _rect585, _rect586, _rect587, _rect588, _rect589, _rect590, _rect591, _rect592, _rect593, _rect594, _rect595, _rect596, _rect597, _rect598, _rect599, _rect600, _rect601, _rect602, _rect603, _rect604, _rect605, _rect606, _rect607, _rect608, _rect609, _rect610, _rect611, _rect612, _rect613, _rect614, _rect615, _rect616, _rect617, _rect618, _rect619, _rect620, _rect621, _rect622, _rect623, _rect624, _rect625, _rect626, _rect627, _rect628, _rect629, _rect630, _rect631, _rect632, _rect633, _rect634, _rect635, _rect636, _rect637, _rect638, _rect639, _rect640, _rect641, _rect642, _rect643, _rect644, _rect645, _rect646, _rect647, _rect648, _rect649, _rect650, _rect651, _rect652, _rect653, _rect654, _rect655, _rect656, _rect657, _rect658, _rect659, _rect660, _rect661, _rect662, _rect663, _rect664, _rect665, _rect666, _rect667, _rect668, _rect669, _rect670, _rect671, _rect672, _rect673, _rect674, _rect675, _rect676, _rect677, _rect678, _rect679, _rect680, _rect681, _rect682, _rect683, _rect684, _rect685, _rect686, _rect687, _rect688, _rect689, _rect690, _rect691, _rect692, _rect693, _rect694, _rect695, _rect696, _rect697, _rect698, _rect699, _rect700, _rect701, _rect702, _rect703, _rect704, _rect705, _rect706, _rect707, _rect708, _rect709, _rect710, _rect711, _rect712, _rect713, _rect714, _rect715, _rect716, _rect717, _rect718, _rect719, _rect720, _rect721, _rect722, _rect723, _rect724, _rect725, _rect726, _rect727, _rect728, _rect729, _rect730, _rect731, _rect732, _rect733, _rect734, _rect735, _rect736, _rect737, _rect738, _rect739, _rect740, _rect741, _rect742, _rect743, _rect744, _rect745, _rect746, _rect747, _rect748, _rect749, _rect750, _rect751, _rect752, _rect753, _rect754, _rect755, _rect756, _rect757, _rect758, _rect759, _rect760, _rect761, _rect762, _rect763, _rect764, _rect765, _rect766, _rect767, _rect768, _rect769, _rect770, _rect771, _rect772, _rect773, _rect774, _rect775, _rect776, _rect777, _rect778, _rect779, _rect780, _rect781, _rect782, _rect783, _rect784, _rect785, _rect786, _rect787, _rect788, _rect789, _rect790, _rect791, _rect792, _rect793, _rect794, _rect795, _rect796, _rect797, _rect798, _rect799, _rect800, _rect801, _rect802, _rect803, _rect804, _rect805, _rect806, _rect807, _rect808, _rect809, _rect810, _rect811, _rect812, _rect813, _rect814, _rect815, _rect816, _rect817, _rect818, _rect819, _rect820, _rect821, _rect822, _rect823, _rect824, _rect825, _rect826, _rect827, _rect828, _rect829, _rect830, _rect831, _rect832, _rect833, _rect834, _rect835, _rect836, _rect837, _rect838, _rect839, _rect840, _rect841, _rect842, _rect843, _rect844, _rect845, _rect846, _rect847, _rect848, _rect849, _rect850, _rect851, _rect852, _rect853, _rect854, _rect855, _rect856, _rect857, _rect858, _rect859, _rect860, _rect861, _rect862, _rect863, _rect864, _rect865, _rect866, _rect867, _rect868, _rect869, _rect870, _rect871, _rect872, _rect873, _rect874, _rect875, _rect876, _rect877, _rect878, _rect879, _rect880, _rect881, _rect882, _rect883, _rect884, _rect885, _rect886;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstPClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1120 1120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .firstP0C.fill,\n      .firstP1C.fill,\n      .firstP2C.fill,\n      .firstP3C.fill,\n      .firstP4C.fill,\n      .firstP5C.fill{\n        fill: lightgrey;\n        transition: fill 0.5s ease-in-out;\n      }\n      .firstP0C.show {\n        fill: #fff200;\n      }\n\n      .firstP1C.show {\n        fill: #fff;\n      }\n\n      .firstP2C.show {\n        fill: #c60307;\n      }\n\n      .firstP3C.show {\n        fill: #ff6d00;\n      }\n\n      .firstP4C.show {\n        fill: #006838;\n      }\n      rect{\n        fill:#fff;  \n      }\n      .firstP5C.show {\n        fill: none;\n        stroke: #231f20;\n        stroke-miterlimit: 10;\n        stroke-width: .25px;\n      }\n\n      .firstP6C.show {\n        fill: #420005;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 32.83,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(-21.11 50.85) rotate(-45)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 58.28,
    y: 58.37,
    width: 36,
    height: 36,
    transform: "translate(-31.66 76.31) rotate(-45)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 109.2,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(-16.74 112.31) rotate(-45)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 160.11,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(-1.83 148.31) rotate(-45)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 211.02,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(13.08 184.31) rotate(-45)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 261.93,
    y: 58.35,
    width: 36,
    height: 36,
    transform: "translate(28 220.3) rotate(-45)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 312.84,
    y: 58.37,
    width: 36,
    height: 36,
    transform: "translate(42.9 256.31) rotate(-45)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 363.75,
    y: 58.37,
    width: 36,
    height: 36,
    transform: "translate(57.81 292.31) rotate(-45)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 414.67,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(72.73 328.31) rotate(-45)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 465.58,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(87.64 364.31) rotate(-45)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 516.49,
    y: 58.36,
    width: 36,
    height: 36,
    transform: "translate(102.55 400.31) rotate(-45)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 83.74,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(-6.2 86.85) rotate(-45)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 134.65,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(8.71 122.85) rotate(-45)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 185.56,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(23.62 158.85) rotate(-45)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 236.47,
    y: 32.9,
    width: 36,
    height: 36,
    transform: "translate(38.54 194.85) rotate(-45)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 287.39,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(53.45 230.85) rotate(-45)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 338.3,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(68.36 266.85) rotate(-45)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 389.21,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(83.27 302.85) rotate(-45)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 440.12,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(98.18 338.85) rotate(-45)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 491.03,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(113.09 374.85) rotate(-45)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 541.94,
    y: 32.9,
    width: 36,
    height: 36,
    transform: "translate(128.01 410.85) rotate(-45)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 32.83,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(-57.11 65.76) rotate(-45)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 58.29,
    y: 109.28,
    width: 36,
    height: 36,
    transform: "translate(-67.66 91.22) rotate(-45)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 109.2,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(-52.74 127.22) rotate(-45)"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 160.11,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(-37.83 163.22) rotate(-45)"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 211.02,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(-22.92 199.22) rotate(-45)"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 261.92,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(-8.01 235.21) rotate(-45)"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 312.84,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(6.91 271.22) rotate(-45)"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 363.76,
    y: 109.28,
    width: 36,
    height: 36,
    transform: "translate(21.81 307.22) rotate(-45)"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 414.67,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(36.73 343.22) rotate(-45)"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 465.58,
    y: 109.27,
    width: 36,
    height: 36,
    transform: "translate(51.64 379.22) rotate(-45)"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 516.48,
    y: 109.28,
    width: 36,
    height: 36,
    transform: "translate(66.55 415.21) rotate(-45)"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 83.74,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(-42.2 101.76) rotate(-45)"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 134.65,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(-27.29 137.76) rotate(-45)"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 185.57,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(-12.37 173.77) rotate(-45)"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 236.48,
    y: 83.81,
    width: 36,
    height: 36,
    transform: "translate(2.54 209.77) rotate(-45)"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP0C",
    x: 287.38,
    y: 83.81,
    width: 36,
    height: 36,
    transform: "translate(17.46 245.76) rotate(-45)"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 338.3,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(32.36 281.76) rotate(-45)"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 389.21,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(47.27 317.76) rotate(-45)"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 440.12,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(62.18 353.76) rotate(-45)"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 491.04,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(77.1 389.77) rotate(-45)"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 541.94,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(92.01 425.76) rotate(-45)"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 32.83,
    y: 134.72,
    width: 36,
    height: 36,
    transform: "translate(-93.1 80.67) rotate(-45)"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 58.28,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(-103.65 106.13) rotate(-45)"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 109.2,
    y: 160.2,
    width: 36,
    height: 36,
    transform: "translate(-88.75 142.14) rotate(-45)"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 160.11,
    y: 160.19,
    width: 36,
    height: 36,
    transform: "translate(-73.83 178.13) rotate(-45)"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 211.02,
    y: 160.19,
    width: 36,
    height: 36,
    transform: "translate(-58.92 214.13) rotate(-45)"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 261.93,
    y: 160.19,
    width: 36,
    height: 36,
    transform: "translate(-44.01 250.13) rotate(-45)"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 312.85,
    y: 160.19,
    width: 36,
    height: 36,
    transform: "translate(-29.1 286.13) rotate(-45)"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 363.75,
    y: 160.18,
    width: 36,
    height: 36,
    transform: "translate(-14.18 322.13) rotate(-45)"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 414.67,
    y: 160.2,
    width: 36,
    height: 36,
    transform: "translate(.72 358.14) rotate(-45)"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 465.58,
    y: 160.19,
    width: 36,
    height: 36,
    transform: "translate(15.64 394.13) rotate(-45)"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 516.49,
    y: 160.19,
    width: 36,
    height: 36,
    transform: "translate(30.55 430.13) rotate(-45)"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 83.75,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(-78.19 116.68) rotate(-45)"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 134.66,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(-63.28 152.68) rotate(-45)"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 185.57,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(-48.37 188.68) rotate(-45)"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 236.47,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(-33.46 224.67) rotate(-45)"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP0C",
    x: 287.39,
    y: 134.72,
    width: 36,
    height: 36,
    transform: "translate(-18.54 260.67) rotate(-45)"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 338.3,
    y: 134.72,
    width: 36,
    height: 36,
    transform: "translate(-3.63 296.67) rotate(-45)"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 389.22,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(11.28 332.68) rotate(-45)"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 440.13,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(26.19 368.68) rotate(-45)"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 491.03,
    y: 134.74,
    width: 36,
    height: 36,
    transform: "translate(41.09 404.68) rotate(-45)"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 541.94,
    y: 134.73,
    width: 36,
    height: 36,
    transform: "translate(56.01 440.67) rotate(-45)"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 32.83,
    y: 185.64,
    width: 36,
    height: 36,
    transform: "translate(-129.11 95.59) rotate(-45)"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 58.29,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(-139.65 121.05) rotate(-45)"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 109.2,
    y: 211.1,
    width: 36,
    height: 36,
    transform: "translate(-124.74 157.04) rotate(-45)"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 160.11,
    y: 211.1,
    width: 36,
    height: 36,
    transform: "translate(-109.83 193.04) rotate(-45)"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 211.02,
    y: 211.1,
    width: 36,
    height: 36,
    transform: "translate(-94.92 229.04) rotate(-45)"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 261.93,
    y: 211.1,
    width: 36,
    height: 36,
    transform: "translate(-80.01 265.04) rotate(-45)"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 312.84,
    y: 211.1,
    width: 36,
    height: 36,
    transform: "translate(-65.1 301.04) rotate(-45)"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 363.76,
    y: 211.09,
    width: 36,
    height: 36,
    transform: "translate(-50.18 337.05) rotate(-45)"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 414.66,
    y: 211.1,
    width: 36,
    height: 36,
    transform: "translate(-35.27 373.04) rotate(-45)"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 465.58,
    y: 211.1,
    width: 36,
    height: 36,
    transform: "translate(-20.36 409.04) rotate(-45)"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 516.49,
    y: 211.1,
    width: 36,
    height: 36,
    transform: "translate(-5.45 445.04) rotate(-45)"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 83.74,
    y: 185.63,
    width: 36,
    height: 36,
    transform: "translate(-114.19 131.58) rotate(-45)"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 134.65,
    y: 185.64,
    width: 36,
    height: 36,
    transform: "translate(-99.29 167.59) rotate(-45)"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 185.56,
    y: 185.65,
    width: 36,
    height: 36,
    transform: "translate(-84.38 203.59) rotate(-45)"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 236.47,
    y: 185.65,
    width: 36,
    height: 36,
    transform: "translate(-69.47 239.59) rotate(-45)"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP0C",
    x: 287.39,
    y: 185.64,
    width: 36,
    height: 36,
    transform: "translate(-54.55 275.59) rotate(-45)"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 338.3,
    y: 185.64,
    width: 36,
    height: 36,
    transform: "translate(-39.64 311.59) rotate(-45)"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 389.21,
    y: 185.63,
    width: 36,
    height: 36,
    transform: "translate(-24.72 347.58) rotate(-45)"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 440.11,
    y: 185.65,
    width: 36,
    height: 36,
    transform: "translate(-9.82 383.58) rotate(-45)"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 491.03,
    y: 185.65,
    width: 36,
    height: 36,
    transform: "translate(5.09 419.59) rotate(-45)"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 541.94,
    y: 185.65,
    width: 36,
    height: 36,
    transform: "translate(20 455.59) rotate(-45)"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 32.83,
    y: 236.55,
    width: 36,
    height: 36,
    transform: "translate(-165.11 110.5) rotate(-45)"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 58.29,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(-175.65 135.96) rotate(-45)"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 109.19,
    y: 262.01,
    width: 36,
    height: 36,
    transform: "translate(-160.74 171.95) rotate(-45)"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 160.1,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(-145.82 207.95) rotate(-45)"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 211.02,
    y: 262.01,
    width: 36,
    height: 36,
    transform: "translate(-130.92 243.95) rotate(-45)"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 261.93,
    y: 262.01,
    width: 36,
    height: 36,
    transform: "translate(-116.01 279.95) rotate(-45)"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 312.84,
    y: 262.01,
    width: 36,
    height: 36,
    transform: "translate(-101.1 315.95) rotate(-45)"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 363.75,
    y: 262.01,
    width: 36,
    height: 36,
    transform: "translate(-86.18 351.95) rotate(-45)"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 414.66,
    y: 262.01,
    width: 36,
    height: 36,
    transform: "translate(-71.27 387.95) rotate(-45)"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 465.57,
    y: 262,
    width: 36,
    height: 36,
    transform: "translate(-56.35 423.95) rotate(-45)"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 516.49,
    y: 262.01,
    width: 36,
    height: 36,
    transform: "translate(-41.45 459.95) rotate(-45)"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 83.74,
    y: 236.54,
    width: 36,
    height: 36,
    transform: "translate(-150.19 146.49) rotate(-45)"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 134.64,
    y: 236.55,
    width: 36,
    height: 36,
    transform: "translate(-135.29 182.49) rotate(-45)"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 185.56,
    y: 236.56,
    width: 36,
    height: 36,
    transform: "translate(-120.38 218.5) rotate(-45)"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 236.47,
    y: 236.56,
    width: 36,
    height: 36,
    transform: "translate(-105.47 254.5) rotate(-45)"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 287.39,
    y: 236.55,
    width: 36,
    height: 36,
    transform: "translate(-90.55 290.5) rotate(-45)"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 338.3,
    y: 236.55,
    width: 36,
    height: 36,
    transform: "translate(-75.64 326.5) rotate(-45)"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 389.2,
    y: 236.55,
    width: 36,
    height: 36,
    transform: "translate(-60.73 362.49) rotate(-45)"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 440.11,
    y: 236.55,
    width: 36,
    height: 36,
    transform: "translate(-45.82 398.49) rotate(-45)"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 491.03,
    y: 236.56,
    width: 36,
    height: 36,
    transform: "translate(-30.91 434.5) rotate(-45)"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 541.94,
    y: 236.56,
    width: 36,
    height: 36,
    transform: "translate(-16 470.5) rotate(-45)"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 32.83,
    y: 287.47,
    width: 36,
    height: 36,
    transform: "translate(-201.11 125.41) rotate(-45)"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 58.28,
    y: 312.93,
    width: 36,
    height: 36,
    transform: "translate(-211.66 150.87) rotate(-45)"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 109.2,
    y: 312.92,
    width: 36,
    height: 36,
    transform: "translate(-196.74 186.87) rotate(-45)"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 160.11,
    y: 312.92,
    width: 36,
    height: 36,
    transform: "translate(-181.83 222.87) rotate(-45)"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 211.02,
    y: 312.92,
    width: 36,
    height: 36,
    transform: "translate(-166.92 258.87) rotate(-45)"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 261.93,
    y: 312.92,
    width: 36,
    height: 36,
    transform: "translate(-152.01 294.87) rotate(-45)"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 312.83,
    y: 312.93,
    width: 36,
    height: 36,
    transform: "translate(-137.1 330.86) rotate(-45)"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 363.75,
    y: 312.93,
    width: 36,
    height: 36,
    transform: "translate(-122.19 366.87) rotate(-45)"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 414.67,
    y: 312.92,
    width: 36,
    height: 36,
    transform: "translate(-107.27 402.87) rotate(-45)"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 465.58,
    y: 312.92,
    width: 36,
    height: 36,
    transform: "translate(-92.36 438.87) rotate(-45)"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 516.49,
    y: 312.92,
    width: 36,
    height: 36,
    transform: "translate(-77.45 474.87) rotate(-45)"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP0C",
    x: 83.74,
    y: 287.47,
    width: 36,
    height: 36,
    transform: "translate(-186.2 161.41) rotate(-45)"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP0C",
    x: 134.65,
    y: 287.47,
    width: 36,
    height: 36,
    transform: "translate(-171.29 197.41) rotate(-45)"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP0C",
    x: 185.57,
    y: 287.47,
    width: 36,
    height: 36,
    transform: "translate(-156.38 233.41) rotate(-45)"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 236.47,
    y: 287.47,
    width: 36,
    height: 36,
    transform: "translate(-141.46 269.41) rotate(-45)"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 287.39,
    y: 287.47,
    width: 36,
    height: 36,
    transform: "translate(-126.55 305.41) rotate(-45)"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 338.3,
    y: 287.47,
    width: 36,
    height: 36,
    transform: "translate(-111.64 341.41) rotate(-45)"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP0C",
    x: 389.21,
    y: 287.47,
    width: 36,
    height: 36,
    transform: "translate(-96.73 377.41) rotate(-45)"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP0C",
    x: 440.12,
    y: 287.47,
    width: 36,
    height: 36,
    transform: "translate(-81.82 413.41) rotate(-45)"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP0C",
    x: 491.04,
    y: 287.47,
    width: 36,
    height: 36,
    transform: "translate(-66.91 449.41) rotate(-45)"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 541.94,
    y: 287.47,
    width: 36,
    height: 36,
    transform: "translate(-51.99 485.41) rotate(-45)"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 32.83,
    y: 338.38,
    width: 36,
    height: 36,
    transform: "translate(-237.11 140.32) rotate(-45)"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 58.28,
    y: 363.84,
    width: 36,
    height: 36,
    transform: "translate(-247.66 165.78) rotate(-45)"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 109.2,
    y: 363.83,
    width: 36,
    height: 36,
    transform: "translate(-232.74 201.78) rotate(-45)"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 160.11,
    y: 363.83,
    width: 36,
    height: 36,
    transform: "translate(-217.83 237.78) rotate(-45)"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 211.02,
    y: 363.83,
    width: 36,
    height: 36,
    transform: "translate(-202.92 273.78) rotate(-45)"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 261.92,
    y: 363.83,
    width: 36,
    height: 36,
    transform: "translate(-188.01 309.77) rotate(-45)"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 312.83,
    y: 363.84,
    width: 36,
    height: 36,
    transform: "translate(-173.1 345.77) rotate(-45)"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 363.75,
    y: 363.84,
    width: 36,
    height: 36,
    transform: "translate(-158.19 381.78) rotate(-45)"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 414.67,
    y: 363.83,
    width: 36,
    height: 36,
    transform: "translate(-143.27 417.78) rotate(-45)"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 465.58,
    y: 363.83,
    width: 36,
    height: 36,
    transform: "translate(-128.36 453.78) rotate(-45)"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 516.49,
    y: 363.83,
    width: 36,
    height: 36,
    transform: "translate(-113.45 489.78) rotate(-45)"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 83.74,
    y: 338.38,
    width: 36,
    height: 36,
    transform: "translate(-222.2 176.32) rotate(-45)"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 134.65,
    y: 338.38,
    width: 36,
    height: 36,
    transform: "translate(-207.29 212.32) rotate(-45)"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 185.56,
    y: 338.38,
    width: 36,
    height: 36,
    transform: "translate(-192.38 248.32) rotate(-45)"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 236.47,
    y: 338.37,
    width: 36,
    height: 36,
    transform: "translate(-177.46 284.32) rotate(-45)"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 287.39,
    y: 338.38,
    width: 36,
    height: 36,
    transform: "translate(-162.55 320.32) rotate(-45)"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 338.3,
    y: 338.38,
    width: 36,
    height: 36,
    transform: "translate(-147.64 356.32) rotate(-45)"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 389.21,
    y: 338.38,
    width: 36,
    height: 36,
    transform: "translate(-132.73 392.32) rotate(-45)"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 440.12,
    y: 338.38,
    width: 36,
    height: 36,
    transform: "translate(-117.82 428.32) rotate(-45)"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 491.03,
    y: 338.38,
    width: 36,
    height: 36,
    transform: "translate(-102.91 464.32) rotate(-45)"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 541.94,
    y: 338.37,
    width: 36,
    height: 36,
    transform: "translate(-87.99 500.32) rotate(-45)"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 32.83,
    y: 389.29,
    width: 36,
    height: 36,
    transform: "translate(-273.11 155.23) rotate(-45)"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 58.29,
    y: 414.75,
    width: 36,
    height: 36,
    transform: "translate(-283.66 180.69) rotate(-45)"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 109.2,
    y: 414.74,
    width: 36,
    height: 36,
    transform: "translate(-268.74 216.69) rotate(-45)"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 160.11,
    y: 414.74,
    width: 36,
    height: 36,
    transform: "translate(-253.83 252.69) rotate(-45)"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 211.01,
    y: 414.75,
    width: 36,
    height: 36,
    transform: "translate(-238.92 288.68) rotate(-45)"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 261.92,
    y: 414.74,
    width: 36,
    height: 36,
    transform: "translate(-224.01 324.68) rotate(-45)"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP5C",
    x: 312.83,
    y: 414.74,
    width: 36,
    height: 36,
    transform: "translate(-209.1 360.68) rotate(-45)"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 363.76,
    y: 414.75,
    width: 36,
    height: 36,
    transform: "translate(-194.19 396.69) rotate(-45)"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 414.67,
    y: 414.74,
    width: 36,
    height: 36,
    transform: "translate(-179.27 432.69) rotate(-45)"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 465.58,
    y: 414.74,
    width: 36,
    height: 36,
    transform: "translate(-164.36 468.69) rotate(-45)"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 516.48,
    y: 414.75,
    width: 36,
    height: 36,
    transform: "translate(-149.45 504.68) rotate(-45)"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 83.74,
    y: 389.29,
    width: 36,
    height: 36,
    transform: "translate(-258.2 191.23) rotate(-45)"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 134.65,
    y: 389.29,
    width: 36,
    height: 36,
    transform: "translate(-243.29 227.23) rotate(-45)"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 185.57,
    y: 389.29,
    width: 36,
    height: 36,
    transform: "translate(-228.37 263.24) rotate(-45)"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 236.47,
    y: 389.29,
    width: 36,
    height: 36,
    transform: "translate(-213.46 299.23) rotate(-45)"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP0C",
    x: 287.38,
    y: 389.28,
    width: 36,
    height: 36,
    transform: "translate(-198.54 335.23) rotate(-45)"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 338.3,
    y: 389.29,
    width: 36,
    height: 36,
    transform: "translate(-183.64 371.23) rotate(-45)"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 389.21,
    y: 389.29,
    width: 36,
    height: 36,
    transform: "translate(-168.73 407.23) rotate(-45)"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 440.12,
    y: 389.29,
    width: 36,
    height: 36,
    transform: "translate(-153.82 443.23) rotate(-45)"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 491.04,
    y: 389.29,
    width: 36,
    height: 36,
    transform: "translate(-138.9 479.24) rotate(-45)"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 541.94,
    y: 389.29,
    width: 36,
    height: 36,
    transform: "translate(-123.99 515.23) rotate(-45)"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 32.83,
    y: 440.19,
    width: 36,
    height: 36,
    transform: "translate(-309.1 170.14) rotate(-45)"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 58.28,
    y: 465.65,
    width: 36,
    height: 36,
    transform: "translate(-319.65 195.6) rotate(-45)"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 109.2,
    y: 465.67,
    width: 36,
    height: 36,
    transform: "translate(-304.75 231.61) rotate(-45)"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 160.11,
    y: 465.66,
    width: 36,
    height: 36,
    transform: "translate(-289.83 267.6) rotate(-45)"
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 211.02,
    y: 465.66,
    width: 36,
    height: 36,
    transform: "translate(-274.92 303.6) rotate(-45)"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 261.93,
    y: 465.66,
    width: 36,
    height: 36,
    transform: "translate(-260.01 339.6) rotate(-45)"
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 312.84,
    y: 465.66,
    width: 36,
    height: 36,
    transform: "translate(-245.1 375.6) rotate(-45)"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 363.75,
    y: 465.65,
    width: 36,
    height: 36,
    transform: "translate(-230.18 411.6) rotate(-45)"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 414.67,
    y: 465.67,
    width: 36,
    height: 36,
    transform: "translate(-215.28 447.61) rotate(-45)"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 465.58,
    y: 465.66,
    width: 36,
    height: 36,
    transform: "translate(-200.36 483.6) rotate(-45)"
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 516.49,
    y: 465.66,
    width: 36,
    height: 36,
    transform: "translate(-185.45 519.6) rotate(-45)"
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 83.75,
    y: 440.2,
    width: 36,
    height: 36,
    transform: "translate(-294.19 206.15) rotate(-45)"
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 134.66,
    y: 440.2,
    width: 36,
    height: 36,
    transform: "translate(-279.28 242.15) rotate(-45)"
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 185.56,
    y: 440.21,
    width: 36,
    height: 36,
    transform: "translate(-264.38 278.15) rotate(-45)"
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 236.47,
    y: 440.2,
    width: 36,
    height: 36,
    transform: "translate(-249.46 314.14) rotate(-45)"
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP0C",
    x: 287.39,
    y: 440.19,
    width: 36,
    height: 36,
    transform: "translate(-234.54 350.14) rotate(-45)"
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 338.3,
    y: 440.19,
    width: 36,
    height: 36,
    transform: "translate(-219.63 386.14) rotate(-45)"
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 312.84,
    y: 414.75,
    width: 36,
    height: 36,
    transform: "translate(-209.1 360.69) rotate(-45)"
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 389.22,
    y: 440.2,
    width: 36,
    height: 36,
    transform: "translate(-204.72 422.15) rotate(-45)"
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 440.13,
    y: 440.2,
    width: 36,
    height: 36,
    transform: "translate(-189.81 458.15) rotate(-45)"
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 491.03,
    y: 440.21,
    width: 36,
    height: 36,
    transform: "translate(-174.91 494.15) rotate(-45)"
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 541.94,
    y: 440.2,
    width: 36,
    height: 36,
    transform: "translate(-159.99 530.14) rotate(-45)"
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 32.83,
    y: 491.11,
    width: 36,
    height: 36,
    transform: "translate(-345.11 185.06) rotate(-45)"
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 58.29,
    y: 516.56,
    width: 36,
    height: 36,
    transform: "translate(-355.65 210.52) rotate(-45)"
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 109.19,
    y: 516.57,
    width: 36,
    height: 36,
    transform: "translate(-340.74 246.51) rotate(-45)"
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 160.11,
    y: 516.57,
    width: 36,
    height: 36,
    transform: "translate(-325.83 282.51) rotate(-45)"
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 211.02,
    y: 516.57,
    width: 36,
    height: 36,
    transform: "translate(-310.92 318.51) rotate(-45)"
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 261.93,
    y: 516.57,
    width: 36,
    height: 36,
    transform: "translate(-296.01 354.51) rotate(-45)"
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 312.84,
    y: 516.57,
    width: 36,
    height: 36,
    transform: "translate(-281.1 390.51) rotate(-45)"
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 363.76,
    y: 516.56,
    width: 36,
    height: 36,
    transform: "translate(-266.18 426.52) rotate(-45)"
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 414.66,
    y: 516.57,
    width: 36,
    height: 36,
    transform: "translate(-251.27 462.51) rotate(-45)"
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 465.58,
    y: 516.57,
    width: 36,
    height: 36,
    transform: "translate(-236.36 498.51) rotate(-45)"
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 516.49,
    y: 516.57,
    width: 36,
    height: 36,
    transform: "translate(-221.45 534.51) rotate(-45)"
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 83.74,
    y: 491.1,
    width: 36,
    height: 36,
    transform: "translate(-330.19 221.05) rotate(-45)"
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 134.64,
    y: 491.12,
    width: 36,
    height: 36,
    transform: "translate(-315.29 257.05) rotate(-45)"
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 185.55,
    y: 491.12,
    width: 36,
    height: 36,
    transform: "translate(-300.38 293.05) rotate(-45)"
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 236.47,
    y: 491.12,
    width: 36,
    height: 36,
    transform: "translate(-285.47 329.06) rotate(-45)"
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP0C",
    x: 287.39,
    y: 491.11,
    width: 36,
    height: 36,
    transform: "translate(-270.55 365.06) rotate(-45)"
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 338.3,
    y: 491.11,
    width: 36,
    height: 36,
    transform: "translate(-255.64 401.06) rotate(-45)"
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 389.21,
    y: 491.1,
    width: 36,
    height: 36,
    transform: "translate(-240.72 437.05) rotate(-45)"
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 440.11,
    y: 491.12,
    width: 36,
    height: 36,
    transform: "translate(-225.82 473.05) rotate(-45)"
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 491.03,
    y: 491.12,
    width: 36,
    height: 36,
    transform: "translate(-210.91 509.06) rotate(-45)"
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 541.94,
    y: 491.12,
    width: 36,
    height: 36,
    transform: "translate(-196 545.06) rotate(-45)"
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 32.83,
    y: 542.02,
    width: 36,
    height: 36,
    transform: "translate(-381.11 199.97) rotate(-45)"
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 83.73,
    y: 542.02,
    width: 36,
    height: 36,
    transform: "translate(-366.2 235.96) rotate(-45)"
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 134.64,
    y: 542.02,
    width: 36,
    height: 36,
    transform: "translate(-351.29 271.96) rotate(-45)"
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 185.55,
    y: 542.03,
    width: 36,
    height: 36,
    transform: "translate(-336.38 307.96) rotate(-45)"
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 236.47,
    y: 542.03,
    width: 36,
    height: 36,
    transform: "translate(-321.47 343.97) rotate(-45)"
  })), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 287.39,
    y: 542.02,
    width: 36,
    height: 36,
    transform: "translate(-306.55 379.97) rotate(-45)"
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 338.3,
    y: 542.02,
    width: 36,
    height: 36,
    transform: "translate(-291.64 415.97) rotate(-45)"
  })), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 389.2,
    y: 542.02,
    width: 36,
    height: 36,
    transform: "translate(-276.73 451.96) rotate(-45)"
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 440.11,
    y: 542.02,
    width: 36,
    height: 36,
    transform: "translate(-261.82 487.96) rotate(-45)"
  })), _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 491.03,
    y: 542.03,
    width: 36,
    height: 36,
    transform: "translate(-246.91 523.97) rotate(-45)"
  })), _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 541.94,
    y: 542.03,
    width: 36,
    height: 36,
    transform: "translate(-232 559.97) rotate(-45)"
  })), _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 542.06,
    y: 32.83,
    width: 36,
    height: 36,
    transform: "translate(128.1 410.91) rotate(-45)"
  })), _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 567.51,
    y: 58.28,
    width: 36,
    height: 36,
    transform: "translate(117.55 436.36) rotate(-45)"
  })), _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 618.41,
    y: 58.29,
    width: 36,
    height: 36,
    transform: "translate(132.46 472.35) rotate(-45)"
  })), _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 669.33,
    y: 58.28,
    width: 36,
    height: 36,
    transform: "translate(147.38 508.36) rotate(-45)"
  })), _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 720.25,
    y: 58.28,
    width: 36,
    height: 36,
    transform: "translate(162.29 544.36) rotate(-45)"
  })), _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 771.16,
    y: 58.28,
    width: 36,
    height: 36,
    transform: "translate(177.2 580.36) rotate(-45)"
  })), _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 822.07,
    y: 58.28,
    width: 36,
    height: 36,
    transform: "translate(192.11 616.36) rotate(-45)"
  })), _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 872.98,
    y: 58.28,
    width: 36,
    height: 36,
    transform: "translate(207.02 652.36) rotate(-45)"
  })), _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 923.88,
    y: 58.29,
    width: 36,
    height: 36,
    transform: "translate(221.93 688.35) rotate(-45)"
  })), _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 974.8,
    y: 58.28,
    width: 36,
    height: 36,
    transform: "translate(236.85 724.36) rotate(-45)"
  })), _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 1025.72,
    y: 58.28,
    width: 36,
    height: 36,
    transform: "translate(251.76 760.36) rotate(-45)"
  })), _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 592.97,
    y: 32.83,
    width: 36,
    height: 36,
    transform: "translate(143.01 446.91) rotate(-45)"
  })), _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 643.88,
    y: 32.83,
    width: 36,
    height: 36,
    transform: "translate(157.92 482.91) rotate(-45)"
  })), _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 694.79,
    y: 32.83,
    width: 36,
    height: 36,
    transform: "translate(172.83 518.91) rotate(-45)"
  })), _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 745.7,
    y: 32.83,
    width: 36,
    height: 36,
    transform: "translate(187.74 554.91) rotate(-45)"
  })), _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 796.62,
    y: 32.84,
    width: 36,
    height: 36,
    transform: "translate(202.65 590.91) rotate(-45)"
  })), _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 847.53,
    y: 32.83,
    width: 36,
    height: 36,
    transform: "translate(217.57 626.91) rotate(-45)"
  })), _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 898.44,
    y: 32.83,
    width: 36,
    height: 36,
    transform: "translate(232.48 662.91) rotate(-45)"
  })), _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 949.35,
    y: 32.83,
    width: 36,
    height: 36,
    transform: "translate(247.39 698.91) rotate(-45)"
  })), _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 1000.26,
    y: 32.83,
    width: 36,
    height: 36,
    transform: "translate(262.3 734.91) rotate(-45)"
  })), _rect243 || (_rect243 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 1051.17,
    y: 32.83,
    width: 36,
    height: 36,
    transform: "translate(277.21 770.91) rotate(-45)"
  })), _rect244 || (_rect244 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 542.06,
    y: 83.74,
    width: 36,
    height: 36,
    transform: "translate(92.1 425.82) rotate(-45)"
  })), _rect245 || (_rect245 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 567.51,
    y: 109.19,
    width: 36,
    height: 36,
    transform: "translate(81.55 451.27) rotate(-45)"
  })), _rect246 || (_rect246 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 618.41,
    y: 109.2,
    width: 36,
    height: 36,
    transform: "translate(96.46 487.26) rotate(-45)"
  })), _rect247 || (_rect247 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 669.33,
    y: 109.19,
    width: 36,
    height: 36,
    transform: "translate(111.38 523.27) rotate(-45)"
  })), _rect248 || (_rect248 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 720.25,
    y: 109.19,
    width: 36,
    height: 36,
    transform: "translate(126.29 559.27) rotate(-45)"
  })), _rect249 || (_rect249 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 771.16,
    y: 109.19,
    width: 36,
    height: 36,
    transform: "translate(141.2 595.27) rotate(-45)"
  })), _rect250 || (_rect250 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 822.07,
    y: 109.19,
    width: 36,
    height: 36,
    transform: "translate(156.11 631.27) rotate(-45)"
  })), _rect251 || (_rect251 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 872.97,
    y: 109.2,
    width: 36,
    height: 36,
    transform: "translate(171.02 667.26) rotate(-45)"
  })), _rect252 || (_rect252 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 923.88,
    y: 109.2,
    width: 36,
    height: 36,
    transform: "translate(185.93 703.26) rotate(-45)"
  })), _rect253 || (_rect253 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 974.8,
    y: 109.19,
    width: 36,
    height: 36,
    transform: "translate(200.85 739.27) rotate(-45)"
  })), _rect254 || (_rect254 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 1025.72,
    y: 109.19,
    width: 36,
    height: 36,
    transform: "translate(215.76 775.27) rotate(-45)"
  })), _rect255 || (_rect255 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 592.97,
    y: 83.74,
    width: 36,
    height: 36,
    transform: "translate(107.01 461.82) rotate(-45)"
  })), _rect256 || (_rect256 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 643.88,
    y: 83.74,
    width: 36,
    height: 36,
    transform: "translate(121.92 497.82) rotate(-45)"
  })), _rect257 || (_rect257 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 694.79,
    y: 83.74,
    width: 36,
    height: 36,
    transform: "translate(136.83 533.82) rotate(-45)"
  })), _rect258 || (_rect258 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 745.7,
    y: 83.74,
    width: 36,
    height: 36,
    transform: "translate(151.74 569.82) rotate(-45)"
  })), _rect259 || (_rect259 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 796.61,
    y: 83.73,
    width: 36,
    height: 36,
    transform: "translate(166.66 605.81) rotate(-45)"
  })), _rect260 || (_rect260 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 847.53,
    y: 83.74,
    width: 36,
    height: 36,
    transform: "translate(181.57 641.82) rotate(-45)"
  })), _rect261 || (_rect261 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 898.44,
    y: 83.74,
    width: 36,
    height: 36,
    transform: "translate(196.48 677.82) rotate(-45)"
  })), _rect262 || (_rect262 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 949.35,
    y: 83.74,
    width: 36,
    height: 36,
    transform: "translate(211.39 713.82) rotate(-45)"
  })), _rect263 || (_rect263 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 1000.26,
    y: 83.74,
    width: 36,
    height: 36,
    transform: "translate(226.3 749.82) rotate(-45)"
  })), _rect264 || (_rect264 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 1051.17,
    y: 83.74,
    width: 36,
    height: 36,
    transform: "translate(241.21 785.82) rotate(-45)"
  })), _rect265 || (_rect265 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 542.06,
    y: 134.65,
    width: 36,
    height: 36,
    transform: "translate(56.1 440.73) rotate(-45)"
  })), _rect266 || (_rect266 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 567.51,
    y: 160.11,
    width: 36,
    height: 36,
    transform: "translate(45.55 466.19) rotate(-45)"
  })), _rect267 || (_rect267 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 618.43,
    y: 160.12,
    width: 36,
    height: 36,
    transform: "translate(60.45 502.19) rotate(-45)"
  })), _rect268 || (_rect268 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 669.34,
    y: 160.12,
    width: 36,
    height: 36,
    transform: "translate(75.37 538.19) rotate(-45)"
  })), _rect269 || (_rect269 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 720.25,
    y: 160.11,
    width: 36,
    height: 36,
    transform: "translate(90.29 574.19) rotate(-45)"
  })), _rect270 || (_rect270 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 771.16,
    y: 160.11,
    width: 36,
    height: 36,
    transform: "translate(105.2 610.19) rotate(-45)"
  })), _rect271 || (_rect271 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 822.07,
    y: 160.11,
    width: 36,
    height: 36,
    transform: "translate(120.11 646.19) rotate(-45)"
  })), _rect272 || (_rect272 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 872.98,
    y: 160.11,
    width: 36,
    height: 36,
    transform: "translate(135.02 682.19) rotate(-45)"
  })), _rect273 || (_rect273 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 923.9,
    y: 160.12,
    width: 36,
    height: 36,
    transform: "translate(149.92 718.19) rotate(-45)"
  })), _rect274 || (_rect274 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 974.81,
    y: 160.12,
    width: 36,
    height: 36,
    transform: "translate(164.84 754.19) rotate(-45)"
  })), _rect275 || (_rect275 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 1025.72,
    y: 160.11,
    width: 36,
    height: 36,
    transform: "translate(179.76 790.19) rotate(-45)"
  })), _rect276 || (_rect276 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 592.97,
    y: 134.65,
    width: 36,
    height: 36,
    transform: "translate(71.01 476.73) rotate(-45)"
  })), _rect277 || (_rect277 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 643.88,
    y: 134.65,
    width: 36,
    height: 36,
    transform: "translate(85.92 512.73) rotate(-45)"
  })), _rect278 || (_rect278 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 694.79,
    y: 134.65,
    width: 36,
    height: 36,
    transform: "translate(100.83 548.73) rotate(-45)"
  })), _rect279 || (_rect279 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP3C",
    x: 745.7,
    y: 134.65,
    width: 36,
    height: 36,
    transform: "translate(115.74 584.73) rotate(-45)"
  })), _rect280 || (_rect280 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP3C",
    x: 796.61,
    y: 134.64,
    width: 36,
    height: 36,
    transform: "translate(130.66 620.72) rotate(-45)"
  })), _rect281 || (_rect281 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP3C",
    x: 847.53,
    y: 134.65,
    width: 36,
    height: 36,
    transform: "translate(145.57 656.73) rotate(-45)"
  })), _rect282 || (_rect282 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 898.44,
    y: 134.65,
    width: 36,
    height: 36,
    transform: "translate(160.48 692.73) rotate(-45)"
  })), _rect283 || (_rect283 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 949.35,
    y: 134.65,
    width: 36,
    height: 36,
    transform: "translate(175.39 728.73) rotate(-45)"
  })), _rect284 || (_rect284 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 1000.26,
    y: 134.65,
    width: 36,
    height: 36,
    transform: "translate(190.3 764.73) rotate(-45)"
  })), _rect285 || (_rect285 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 1051.17,
    y: 134.65,
    width: 36,
    height: 36,
    transform: "translate(205.21 800.73) rotate(-45)"
  })), _rect286 || (_rect286 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 542.06,
    y: 185.56,
    width: 36,
    height: 36,
    transform: "translate(20.1 455.64) rotate(-45)"
  })), _rect287 || (_rect287 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 567.51,
    y: 211.02,
    width: 36,
    height: 36,
    transform: "translate(9.55 481.1) rotate(-45)"
  })), _rect288 || (_rect288 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 618.42,
    y: 211.02,
    width: 36,
    height: 36,
    transform: "translate(24.46 517.1) rotate(-45)"
  })), _rect289 || (_rect289 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 669.34,
    y: 211.03,
    width: 36,
    height: 36,
    transform: "translate(39.37 553.1) rotate(-45)"
  })), _rect290 || (_rect290 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 720.25,
    y: 211.02,
    width: 36,
    height: 36,
    transform: "translate(54.29 589.1) rotate(-45)"
  })), _rect291 || (_rect291 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 771.16,
    y: 211.02,
    width: 36,
    height: 36,
    transform: "translate(69.2 625.1) rotate(-45)"
  })), _rect292 || (_rect292 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 822.07,
    y: 211.02,
    width: 36,
    height: 36,
    transform: "translate(84.11 661.1) rotate(-45)"
  })), _rect293 || (_rect293 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 872.98,
    y: 211.02,
    width: 36,
    height: 36,
    transform: "translate(99.02 697.1) rotate(-45)"
  })), _rect294 || (_rect294 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 923.89,
    y: 211.02,
    width: 36,
    height: 36,
    transform: "translate(113.93 733.1) rotate(-45)"
  })), _rect295 || (_rect295 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 974.81,
    y: 211.03,
    width: 36,
    height: 36,
    transform: "translate(128.84 769.1) rotate(-45)"
  })), _rect296 || (_rect296 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 1025.72,
    y: 211.02,
    width: 36,
    height: 36,
    transform: "translate(143.76 805.1) rotate(-45)"
  })), _rect297 || (_rect297 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 592.97,
    y: 185.56,
    width: 36,
    height: 36,
    transform: "translate(35.01 491.64) rotate(-45)"
  })), _rect298 || (_rect298 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 643.88,
    y: 185.56,
    width: 36,
    height: 36,
    transform: "translate(49.92 527.64) rotate(-45)"
  })), _rect299 || (_rect299 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 694.79,
    y: 185.56,
    width: 36,
    height: 36,
    transform: "translate(64.83 563.64) rotate(-45)"
  })), _rect300 || (_rect300 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 745.7,
    y: 185.56,
    width: 36,
    height: 36,
    transform: "translate(79.74 599.64) rotate(-45)"
  })), _rect301 || (_rect301 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 796.6,
    y: 185.56,
    width: 36,
    height: 36,
    transform: "translate(94.65 635.63) rotate(-45)"
  })), _rect302 || (_rect302 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 847.53,
    y: 185.56,
    width: 36,
    height: 36,
    transform: "translate(109.57 671.64) rotate(-45)"
  })), _rect303 || (_rect303 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 898.44,
    y: 185.56,
    width: 36,
    height: 36,
    transform: "translate(124.48 707.64) rotate(-45)"
  })), _rect304 || (_rect304 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 949.35,
    y: 185.56,
    width: 36,
    height: 36,
    transform: "translate(139.39 743.64) rotate(-45)"
  })), _rect305 || (_rect305 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 1000.26,
    y: 185.56,
    width: 36,
    height: 36,
    transform: "translate(154.3 779.64) rotate(-45)"
  })), _rect306 || (_rect306 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 1051.17,
    y: 185.56,
    width: 36,
    height: 36,
    transform: "translate(169.21 815.64) rotate(-45)"
  })), _rect307 || (_rect307 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 542.06,
    y: 236.47,
    width: 36,
    height: 36,
    transform: "translate(-15.9 470.55) rotate(-45)"
  })), _rect308 || (_rect308 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 567.51,
    y: 261.93,
    width: 36,
    height: 36,
    transform: "translate(-26.45 496.01) rotate(-45)"
  })), _rect309 || (_rect309 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 618.42,
    y: 261.93,
    width: 36,
    height: 36,
    transform: "translate(-11.54 532.01) rotate(-45)"
  })), _rect310 || (_rect310 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 669.33,
    y: 261.93,
    width: 36,
    height: 36,
    transform: "translate(3.38 568.01) rotate(-45)"
  })), _rect311 || (_rect311 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 720.25,
    y: 261.93,
    width: 36,
    height: 36,
    transform: "translate(18.29 604.01) rotate(-45)"
  })), _rect312 || (_rect312 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP0C",
    x: 771.16,
    y: 261.93,
    width: 36,
    height: 36,
    transform: "translate(33.2 640.01) rotate(-45)"
  })), _rect313 || (_rect313 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP0C",
    x: 822.07,
    y: 261.93,
    width: 36,
    height: 36,
    transform: "translate(48.11 676.01) rotate(-45)"
  })), _rect314 || (_rect314 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 872.98,
    y: 261.93,
    width: 36,
    height: 36,
    transform: "translate(63.02 712.01) rotate(-45)"
  })), _rect315 || (_rect315 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 923.89,
    y: 261.93,
    width: 36,
    height: 36,
    transform: "translate(77.93 748.01) rotate(-45)"
  })), _rect316 || (_rect316 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 974.8,
    y: 261.93,
    width: 36,
    height: 36,
    transform: "translate(92.85 784.01) rotate(-45)"
  })), _rect317 || (_rect317 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 1025.72,
    y: 261.93,
    width: 36,
    height: 36,
    transform: "translate(107.76 820.01) rotate(-45)"
  })), _rect318 || (_rect318 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 592.97,
    y: 236.47,
    width: 36,
    height: 36,
    transform: "translate(-.99 506.55) rotate(-45)"
  })), _rect319 || (_rect319 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP3C",
    x: 643.88,
    y: 236.47,
    width: 36,
    height: 36,
    transform: "translate(13.92 542.55) rotate(-45)"
  })), _rect320 || (_rect320 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 694.79,
    y: 236.47,
    width: 36,
    height: 36,
    transform: "translate(28.83 578.55) rotate(-45)"
  })), _rect321 || (_rect321 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 745.69,
    y: 236.48,
    width: 36,
    height: 36,
    transform: "translate(43.74 614.54) rotate(-45)"
  })), _rect322 || (_rect322 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 796.6,
    y: 236.47,
    width: 36,
    height: 36,
    transform: "translate(58.65 650.54) rotate(-45)"
  })), _rect323 || (_rect323 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 847.53,
    y: 236.47,
    width: 36,
    height: 36,
    transform: "translate(73.57 686.55) rotate(-45)"
  })), _rect324 || (_rect324 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 898.44,
    y: 236.47,
    width: 36,
    height: 36,
    transform: "translate(88.48 722.55) rotate(-45)"
  })), _rect325 || (_rect325 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP3C",
    x: 949.35,
    y: 236.47,
    width: 36,
    height: 36,
    transform: "translate(103.39 758.55) rotate(-45)"
  })), _rect326 || (_rect326 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 1000.26,
    y: 236.47,
    width: 36,
    height: 36,
    transform: "translate(118.3 794.55) rotate(-45)"
  })), _rect327 || (_rect327 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 1051.16,
    y: 236.48,
    width: 36,
    height: 36,
    transform: "translate(133.21 830.54) rotate(-45)"
  })), _rect328 || (_rect328 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 542.07,
    y: 287.38,
    width: 36,
    height: 36,
    transform: "translate(-51.89 485.47) rotate(-45)"
  })), _rect329 || (_rect329 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 567.51,
    y: 312.84,
    width: 36,
    height: 36,
    transform: "translate(-62.45 510.92) rotate(-45)"
  })), _rect330 || (_rect330 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 618.42,
    y: 312.84,
    width: 36,
    height: 36,
    transform: "translate(-47.54 546.92) rotate(-45)"
  })), _rect331 || (_rect331 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 669.32,
    y: 312.84,
    width: 36,
    height: 36,
    transform: "translate(-32.63 582.91) rotate(-45)"
  })), _rect332 || (_rect332 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 720.25,
    y: 312.84,
    width: 36,
    height: 36,
    transform: "translate(-17.71 618.92) rotate(-45)"
  })), _rect333 || (_rect333 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP0C",
    x: 771.16,
    y: 312.84,
    width: 36,
    height: 36,
    transform: "translate(-2.8 654.92) rotate(-45)"
  })), _rect334 || (_rect334 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP0C",
    x: 822.07,
    y: 312.84,
    width: 36,
    height: 36,
    transform: "translate(12.11 690.92) rotate(-45)"
  })), _rect335 || (_rect335 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 872.98,
    y: 312.84,
    width: 36,
    height: 36,
    transform: "translate(27.02 726.92) rotate(-45)"
  })), _rect336 || (_rect336 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 923.89,
    y: 312.84,
    width: 36,
    height: 36,
    transform: "translate(41.93 762.92) rotate(-45)"
  })), _rect337 || (_rect337 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 974.79,
    y: 312.84,
    width: 36,
    height: 36,
    transform: "translate(56.84 798.91) rotate(-45)"
  })), _rect338 || (_rect338 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 1025.72,
    y: 312.84,
    width: 36,
    height: 36,
    transform: "translate(71.76 834.92) rotate(-45)"
  })), _rect339 || (_rect339 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 592.97,
    y: 287.39,
    width: 36,
    height: 36,
    transform: "translate(-36.99 521.46) rotate(-45)"
  })), _rect340 || (_rect340 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP3C",
    x: 643.88,
    y: 287.39,
    width: 36,
    height: 36,
    transform: "translate(-22.08 557.46) rotate(-45)"
  })), _rect341 || (_rect341 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 694.78,
    y: 287.39,
    width: 36,
    height: 36,
    transform: "translate(-7.17 593.46) rotate(-45)"
  })), _rect342 || (_rect342 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 745.7,
    y: 287.39,
    width: 36,
    height: 36,
    transform: "translate(7.74 629.46) rotate(-45)"
  })), _rect343 || (_rect343 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP0C",
    x: 796.61,
    y: 287.39,
    width: 36,
    height: 36,
    transform: "translate(22.65 665.46) rotate(-45)"
  })), _rect344 || (_rect344 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 847.54,
    y: 287.38,
    width: 36,
    height: 36,
    transform: "translate(37.58 701.47) rotate(-45)"
  })), _rect345 || (_rect345 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 898.44,
    y: 287.39,
    width: 36,
    height: 36,
    transform: "translate(52.48 737.46) rotate(-45)"
  })), _rect346 || (_rect346 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP3C",
    x: 949.35,
    y: 287.39,
    width: 36,
    height: 36,
    transform: "translate(67.39 773.46) rotate(-45)"
  })), _rect347 || (_rect347 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 1000.25,
    y: 287.39,
    width: 36,
    height: 36,
    transform: "translate(82.3 809.46) rotate(-45)"
  })), _rect348 || (_rect348 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 1051.17,
    y: 287.39,
    width: 36,
    height: 36,
    transform: "translate(97.21 845.46) rotate(-45)"
  })), _rect349 || (_rect349 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 542.06,
    y: 338.3,
    width: 36,
    height: 36,
    transform: "translate(-87.9 500.38) rotate(-45)"
  })), _rect350 || (_rect350 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 567.51,
    y: 363.75,
    width: 36,
    height: 36,
    transform: "translate(-98.45 525.83) rotate(-45)"
  })), _rect351 || (_rect351 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 618.41,
    y: 363.76,
    width: 36,
    height: 36,
    transform: "translate(-83.54 561.82) rotate(-45)"
  })), _rect352 || (_rect352 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 669.33,
    y: 363.75,
    width: 36,
    height: 36,
    transform: "translate(-68.62 597.83) rotate(-45)"
  })), _rect353 || (_rect353 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 720.25,
    y: 363.75,
    width: 36,
    height: 36,
    transform: "translate(-53.71 633.83) rotate(-45)"
  })), _rect354 || (_rect354 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 771.16,
    y: 363.75,
    width: 36,
    height: 36,
    transform: "translate(-38.8 669.83) rotate(-45)"
  })), _rect355 || (_rect355 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 822.07,
    y: 363.75,
    width: 36,
    height: 36,
    transform: "translate(-23.89 705.83) rotate(-45)"
  })), _rect356 || (_rect356 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 872.98,
    y: 363.75,
    width: 36,
    height: 36,
    transform: "translate(-8.98 741.83) rotate(-45)"
  })), _rect357 || (_rect357 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 923.88,
    y: 363.76,
    width: 36,
    height: 36,
    transform: "translate(5.93 777.82) rotate(-45)"
  })), _rect358 || (_rect358 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 974.8,
    y: 363.75,
    width: 36,
    height: 36,
    transform: "translate(20.85 813.83) rotate(-45)"
  })), _rect359 || (_rect359 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 1025.72,
    y: 363.75,
    width: 36,
    height: 36,
    transform: "translate(35.76 849.83) rotate(-45)"
  })), _rect360 || (_rect360 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 592.97,
    y: 338.3,
    width: 36,
    height: 36,
    transform: "translate(-72.99 536.38) rotate(-45)"
  })), _rect361 || (_rect361 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP3C",
    x: 643.88,
    y: 338.3,
    width: 36,
    height: 36,
    transform: "translate(-58.08 572.38) rotate(-45)"
  })), _rect362 || (_rect362 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 694.79,
    y: 338.3,
    width: 36,
    height: 36,
    transform: "translate(-43.17 608.38) rotate(-45)"
  })), _rect363 || (_rect363 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 745.7,
    y: 338.3,
    width: 36,
    height: 36,
    transform: "translate(-28.26 644.38) rotate(-45)"
  })), _rect364 || (_rect364 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 796.62,
    y: 338.3,
    width: 36,
    height: 36,
    transform: "translate(-13.35 680.38) rotate(-45)"
  })), _rect365 || (_rect365 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 847.53,
    y: 338.3,
    width: 36,
    height: 36,
    transform: "translate(1.57 716.38) rotate(-45)"
  })), _rect366 || (_rect366 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 898.44,
    y: 338.3,
    width: 36,
    height: 36,
    transform: "translate(16.48 752.38) rotate(-45)"
  })), _rect367 || (_rect367 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP3C",
    x: 949.35,
    y: 338.3,
    width: 36,
    height: 36,
    transform: "translate(31.39 788.38) rotate(-45)"
  })), _rect368 || (_rect368 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 1000.26,
    y: 338.3,
    width: 36,
    height: 36,
    transform: "translate(46.3 824.38) rotate(-45)"
  })), _rect369 || (_rect369 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 1051.17,
    y: 338.3,
    width: 36,
    height: 36,
    transform: "translate(61.21 860.38) rotate(-45)"
  })), _rect370 || (_rect370 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 542.06,
    y: 389.21,
    width: 36,
    height: 36,
    transform: "translate(-123.9 515.29) rotate(-45)"
  })), _rect371 || (_rect371 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 567.51,
    y: 414.67,
    width: 36,
    height: 36,
    transform: "translate(-134.45 540.74) rotate(-45)"
  })), _rect372 || (_rect372 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 618.42,
    y: 414.67,
    width: 36,
    height: 36,
    transform: "translate(-119.54 576.74) rotate(-45)"
  })), _rect373 || (_rect373 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 669.33,
    y: 414.67,
    width: 36,
    height: 36,
    transform: "translate(-104.63 612.74) rotate(-45)"
  })), _rect374 || (_rect374 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 720.26,
    y: 414.66,
    width: 36,
    height: 36,
    transform: "translate(-89.71 648.75) rotate(-45)"
  })), _rect375 || (_rect375 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 771.16,
    y: 414.67,
    width: 36,
    height: 36,
    transform: "translate(-74.8 684.74) rotate(-45)"
  })), _rect376 || (_rect376 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 822.07,
    y: 414.67,
    width: 36,
    height: 36,
    transform: "translate(-59.89 720.74) rotate(-45)"
  })), _rect377 || (_rect377 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 872.98,
    y: 414.67,
    width: 36,
    height: 36,
    transform: "translate(-44.98 756.74) rotate(-45)"
  })), _rect378 || (_rect378 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 923.89,
    y: 414.67,
    width: 36,
    height: 36,
    transform: "translate(-30.07 792.74) rotate(-45)"
  })), _rect379 || (_rect379 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 974.81,
    y: 414.67,
    width: 36,
    height: 36,
    transform: "translate(-15.16 828.75) rotate(-45)"
  })), _rect380 || (_rect380 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 1025.73,
    y: 414.66,
    width: 36,
    height: 36,
    transform: "translate(-.24 864.75) rotate(-45)"
  })), _rect381 || (_rect381 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 592.97,
    y: 389.21,
    width: 36,
    height: 36,
    transform: "translate(-108.99 551.29) rotate(-45)"
  })), _rect382 || (_rect382 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 643.88,
    y: 389.21,
    width: 36,
    height: 36,
    transform: "translate(-94.08 587.29) rotate(-45)"
  })), _rect383 || (_rect383 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 694.79,
    y: 389.21,
    width: 36,
    height: 36,
    transform: "translate(-79.17 623.29) rotate(-45)"
  })), _rect384 || (_rect384 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 745.7,
    y: 389.21,
    width: 36,
    height: 36,
    transform: "translate(-64.26 659.29) rotate(-45)"
  })), _rect385 || (_rect385 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 796.61,
    y: 389.2,
    width: 36,
    height: 36,
    transform: "translate(-49.34 695.28) rotate(-45)"
  })), _rect386 || (_rect386 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 847.53,
    y: 389.21,
    width: 36,
    height: 36,
    transform: "translate(-34.43 731.29) rotate(-45)"
  })), _rect387 || (_rect387 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 898.44,
    y: 389.21,
    width: 36,
    height: 36,
    transform: "translate(-19.52 767.29) rotate(-45)"
  })), _rect388 || (_rect388 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 949.35,
    y: 389.21,
    width: 36,
    height: 36,
    transform: "translate(-4.61 803.29) rotate(-45)"
  })), _rect389 || (_rect389 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 1000.26,
    y: 389.21,
    width: 36,
    height: 36,
    transform: "translate(10.3 839.29) rotate(-45)"
  })), _rect390 || (_rect390 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 1051.17,
    y: 389.21,
    width: 36,
    height: 36,
    transform: "translate(25.21 875.29) rotate(-45)"
  })), _rect391 || (_rect391 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 542.06,
    y: 440.12,
    width: 36,
    height: 36,
    transform: "translate(-159.9 530.2) rotate(-45)"
  })), _rect392 || (_rect392 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 567.51,
    y: 465.58,
    width: 36,
    height: 36,
    transform: "translate(-170.45 555.66) rotate(-45)"
  })), _rect393 || (_rect393 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 618.43,
    y: 465.59,
    width: 36,
    height: 36,
    transform: "translate(-155.55 591.66) rotate(-45)"
  })), _rect394 || (_rect394 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 669.34,
    y: 465.58,
    width: 36,
    height: 36,
    transform: "translate(-140.63 627.66) rotate(-45)"
  })), _rect395 || (_rect395 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 720.25,
    y: 465.58,
    width: 36,
    height: 36,
    transform: "translate(-125.71 663.66) rotate(-45)"
  })), _rect396 || (_rect396 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 771.16,
    y: 465.58,
    width: 36,
    height: 36,
    transform: "translate(-110.8 699.66) rotate(-45)"
  })), _rect397 || (_rect397 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 822.07,
    y: 465.58,
    width: 36,
    height: 36,
    transform: "translate(-95.89 735.66) rotate(-45)"
  })), _rect398 || (_rect398 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 872.98,
    y: 465.58,
    width: 36,
    height: 36,
    transform: "translate(-80.98 771.66) rotate(-45)"
  })), _rect399 || (_rect399 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 923.9,
    y: 465.59,
    width: 36,
    height: 36,
    transform: "translate(-66.08 807.66) rotate(-45)"
  })), _rect400 || (_rect400 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 974.81,
    y: 465.59,
    width: 36,
    height: 36,
    transform: "translate(-51.16 843.66) rotate(-45)"
  })), _rect401 || (_rect401 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 1025.72,
    y: 465.58,
    width: 36,
    height: 36,
    transform: "translate(-36.24 879.66) rotate(-45)"
  })), _rect402 || (_rect402 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 592.97,
    y: 440.12,
    width: 36,
    height: 36,
    transform: "translate(-144.99 566.2) rotate(-45)"
  })), _rect403 || (_rect403 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 643.88,
    y: 440.12,
    width: 36,
    height: 36,
    transform: "translate(-130.08 602.2) rotate(-45)"
  })), _rect404 || (_rect404 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 694.79,
    y: 440.12,
    width: 36,
    height: 36,
    transform: "translate(-115.17 638.2) rotate(-45)"
  })), _rect405 || (_rect405 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP3C",
    x: 745.7,
    y: 440.12,
    width: 36,
    height: 36,
    transform: "translate(-100.26 674.2) rotate(-45)"
  })), _rect406 || (_rect406 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP3C",
    x: 796.61,
    y: 440.11,
    width: 36,
    height: 36,
    transform: "translate(-85.34 710.19) rotate(-45)"
  })), _rect407 || (_rect407 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP3C",
    x: 847.53,
    y: 440.12,
    width: 36,
    height: 36,
    transform: "translate(-70.43 746.2) rotate(-45)"
  })), _rect408 || (_rect408 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 898.44,
    y: 440.12,
    width: 36,
    height: 36,
    transform: "translate(-55.52 782.2) rotate(-45)"
  })), _rect409 || (_rect409 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 949.35,
    y: 440.12,
    width: 36,
    height: 36,
    transform: "translate(-40.61 818.2) rotate(-45)"
  })), _rect410 || (_rect410 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 1000.26,
    y: 440.12,
    width: 36,
    height: 36,
    transform: "translate(-25.7 854.2) rotate(-45)"
  })), _rect411 || (_rect411 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 1051.17,
    y: 440.12,
    width: 36,
    height: 36,
    transform: "translate(-10.79 890.2) rotate(-45)"
  })), _rect412 || (_rect412 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 542.06,
    y: 491.03,
    width: 36,
    height: 36,
    transform: "translate(-195.9 545.11) rotate(-45)"
  })), _rect413 || (_rect413 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 567.51,
    y: 516.49,
    width: 36,
    height: 36,
    transform: "translate(-206.45 570.57) rotate(-45)"
  })), _rect414 || (_rect414 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 618.42,
    y: 516.49,
    width: 36,
    height: 36,
    transform: "translate(-191.54 606.57) rotate(-45)"
  })), _rect415 || (_rect415 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 669.33,
    y: 516.49,
    width: 36,
    height: 36,
    transform: "translate(-176.63 642.57) rotate(-45)"
  })), _rect416 || (_rect416 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 720.25,
    y: 516.49,
    width: 36,
    height: 36,
    transform: "translate(-161.71 678.57) rotate(-45)"
  })), _rect417 || (_rect417 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 771.16,
    y: 516.49,
    width: 36,
    height: 36,
    transform: "translate(-146.8 714.57) rotate(-45)"
  })), _rect418 || (_rect418 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 822.07,
    y: 516.49,
    width: 36,
    height: 36,
    transform: "translate(-131.89 750.57) rotate(-45)"
  })), _rect419 || (_rect419 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 872.98,
    y: 516.49,
    width: 36,
    height: 36,
    transform: "translate(-116.98 786.57) rotate(-45)"
  })), _rect420 || (_rect420 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 923.89,
    y: 516.49,
    width: 36,
    height: 36,
    transform: "translate(-102.07 822.57) rotate(-45)"
  })), _rect421 || (_rect421 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 974.8,
    y: 516.49,
    width: 36,
    height: 36,
    transform: "translate(-87.16 858.57) rotate(-45)"
  })), _rect422 || (_rect422 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 1025.72,
    y: 516.49,
    width: 36,
    height: 36,
    transform: "translate(-72.24 894.57) rotate(-45)"
  })), _rect423 || (_rect423 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 592.97,
    y: 491.03,
    width: 36,
    height: 36,
    transform: "translate(-180.99 581.11) rotate(-45)"
  })), _rect424 || (_rect424 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 643.88,
    y: 491.03,
    width: 36,
    height: 36,
    transform: "translate(-166.08 617.11) rotate(-45)"
  })), _rect425 || (_rect425 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 694.79,
    y: 491.03,
    width: 36,
    height: 36,
    transform: "translate(-151.17 653.11) rotate(-45)"
  })), _rect426 || (_rect426 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 745.7,
    y: 491.03,
    width: 36,
    height: 36,
    transform: "translate(-136.26 689.11) rotate(-45)"
  })), _rect427 || (_rect427 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 796.6,
    y: 491.03,
    width: 36,
    height: 36,
    transform: "translate(-121.35 725.1) rotate(-45)"
  })), _rect428 || (_rect428 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 847.53,
    y: 491.03,
    width: 36,
    height: 36,
    transform: "translate(-106.43 761.11) rotate(-45)"
  })), _rect429 || (_rect429 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 898.44,
    y: 491.03,
    width: 36,
    height: 36,
    transform: "translate(-91.52 797.11) rotate(-45)"
  })), _rect430 || (_rect430 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 949.35,
    y: 491.03,
    width: 36,
    height: 36,
    transform: "translate(-76.61 833.11) rotate(-45)"
  })), _rect431 || (_rect431 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 1000.26,
    y: 491.03,
    width: 36,
    height: 36,
    transform: "translate(-61.7 869.11) rotate(-45)"
  })), _rect432 || (_rect432 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 1051.17,
    y: 491.03,
    width: 36,
    height: 36,
    transform: "translate(-46.79 905.11) rotate(-45)"
  })), _rect433 || (_rect433 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 542.07,
    y: 541.94,
    width: 36,
    height: 36,
    transform: "translate(-231.9 560.03) rotate(-45)"
  })), _rect434 || (_rect434 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 592.98,
    y: 541.94,
    width: 36,
    height: 36,
    transform: "translate(-216.99 596.03) rotate(-45)"
  })), _rect435 || (_rect435 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 643.88,
    y: 541.95,
    width: 36,
    height: 36,
    transform: "translate(-202.08 632.02) rotate(-45)"
  })), _rect436 || (_rect436 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 694.79,
    y: 541.96,
    width: 36,
    height: 36,
    transform: "translate(-187.18 668.03) rotate(-45)"
  })), _rect437 || (_rect437 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 745.7,
    y: 541.95,
    width: 36,
    height: 36,
    transform: "translate(-172.26 704.02) rotate(-45)"
  })), _rect438 || (_rect438 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 796.61,
    y: 541.95,
    width: 36,
    height: 36,
    transform: "translate(-157.35 740.02) rotate(-45)"
  })), _rect439 || (_rect439 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 847.54,
    y: 541.94,
    width: 36,
    height: 36,
    transform: "translate(-142.43 776.03) rotate(-45)"
  })), _rect440 || (_rect440 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 898.45,
    y: 541.94,
    width: 36,
    height: 36,
    transform: "translate(-127.52 812.03) rotate(-45)"
  })), _rect441 || (_rect441 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 949.35,
    y: 541.95,
    width: 36,
    height: 36,
    transform: "translate(-112.61 848.02) rotate(-45)"
  })), _rect442 || (_rect442 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 1000.26,
    y: 541.96,
    width: 36,
    height: 36,
    transform: "translate(-97.71 884.03) rotate(-45)"
  })), _rect443 || (_rect443 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 1051.17,
    y: 541.95,
    width: 36,
    height: 36,
    transform: "translate(-82.79 920.02) rotate(-45)"
  })), _rect444 || (_rect444 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 32.83,
    y: 542.05,
    width: 36,
    height: 36,
    transform: "translate(-381.13 199.98) rotate(-45)"
  })), _rect445 || (_rect445 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 58.28,
    y: 567.51,
    width: 36,
    height: 36,
    transform: "translate(-391.68 225.43) rotate(-45)"
  })), _rect446 || (_rect446 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 109.19,
    y: 567.51,
    width: 36,
    height: 36,
    transform: "translate(-376.76 261.43) rotate(-45)"
  })), _rect447 || (_rect447 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 160.11,
    y: 567.51,
    width: 36,
    height: 36,
    transform: "translate(-361.85 297.43) rotate(-45)"
  })), _rect448 || (_rect448 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 211.02,
    y: 567.51,
    width: 36,
    height: 36,
    transform: "translate(-346.94 333.43) rotate(-45)"
  })), _rect449 || (_rect449 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 261.93,
    y: 567.51,
    width: 36,
    height: 36,
    transform: "translate(-332.03 369.43) rotate(-45)"
  })), _rect450 || (_rect450 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 312.84,
    y: 567.51,
    width: 36,
    height: 36,
    transform: "translate(-317.12 405.43) rotate(-45)"
  })), _rect451 || (_rect451 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 363.75,
    y: 567.51,
    width: 36,
    height: 36,
    transform: "translate(-302.21 441.43) rotate(-45)"
  })), _rect452 || (_rect452 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 414.66,
    y: 567.51,
    width: 36,
    height: 36,
    transform: "translate(-287.29 477.43) rotate(-45)"
  })), _rect453 || (_rect453 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 465.58,
    y: 567.51,
    width: 36,
    height: 36,
    transform: "translate(-272.38 513.43) rotate(-45)"
  })), _rect454 || (_rect454 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 516.49,
    y: 567.51,
    width: 36,
    height: 36,
    transform: "translate(-257.47 549.43) rotate(-45)"
  })), _rect455 || (_rect455 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 83.74,
    y: 542.04,
    width: 36,
    height: 36,
    transform: "translate(-366.21 235.97) rotate(-45)"
  })), _rect456 || (_rect456 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 134.64,
    y: 542.06,
    width: 36,
    height: 36,
    transform: "translate(-351.31 271.97) rotate(-45)"
  })), _rect457 || (_rect457 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 185.55,
    y: 542.06,
    width: 36,
    height: 36,
    transform: "translate(-336.4 307.97) rotate(-45)"
  })), _rect458 || (_rect458 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 236.47,
    y: 542.06,
    width: 36,
    height: 36,
    transform: "translate(-321.49 343.98) rotate(-45)"
  })), _rect459 || (_rect459 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 287.39,
    y: 542.05,
    width: 36,
    height: 36,
    transform: "translate(-306.57 379.98) rotate(-45)"
  })), _rect460 || (_rect460 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 338.3,
    y: 542.05,
    width: 36,
    height: 36,
    transform: "translate(-291.66 415.98) rotate(-45)"
  })), _rect461 || (_rect461 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 389.21,
    y: 542.04,
    width: 36,
    height: 36,
    transform: "translate(-276.74 451.97) rotate(-45)"
  })), _rect462 || (_rect462 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 440.11,
    y: 542.06,
    width: 36,
    height: 36,
    transform: "translate(-261.84 487.97) rotate(-45)"
  })), _rect463 || (_rect463 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 491.02,
    y: 542.06,
    width: 36,
    height: 36,
    transform: "translate(-246.93 523.97) rotate(-45)"
  })), _rect464 || (_rect464 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 541.94,
    y: 542.06,
    width: 36,
    height: 36,
    transform: "translate(-232.02 559.98) rotate(-45)"
  })), _rect465 || (_rect465 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 32.83,
    y: 592.97,
    width: 36,
    height: 36,
    transform: "translate(-417.13 214.89) rotate(-45)"
  })), _rect466 || (_rect466 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 58.27,
    y: 618.43,
    width: 36,
    height: 36,
    transform: "translate(-427.68 240.33) rotate(-45)"
  })), _rect467 || (_rect467 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 109.19,
    y: 618.42,
    width: 36,
    height: 36,
    transform: "translate(-412.76 276.34) rotate(-45)"
  })), _rect468 || (_rect468 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 160.1,
    y: 618.41,
    width: 36,
    height: 36,
    transform: "translate(-397.84 312.34) rotate(-45)"
  })), _rect469 || (_rect469 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 211.02,
    y: 618.42,
    width: 36,
    height: 36,
    transform: "translate(-382.94 348.34) rotate(-45)"
  })), _rect470 || (_rect470 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 261.93,
    y: 618.42,
    width: 36,
    height: 36,
    transform: "translate(-368.03 384.34) rotate(-45)"
  })), _rect471 || (_rect471 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 312.84,
    y: 618.42,
    width: 36,
    height: 36,
    transform: "translate(-353.12 420.34) rotate(-45)"
  })), _rect472 || (_rect472 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 363.74,
    y: 618.43,
    width: 36,
    height: 36,
    transform: "translate(-338.21 456.33) rotate(-45)"
  })), _rect473 || (_rect473 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 414.66,
    y: 618.42,
    width: 36,
    height: 36,
    transform: "translate(-323.29 492.34) rotate(-45)"
  })), _rect474 || (_rect474 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 465.57,
    y: 618.41,
    width: 36,
    height: 36,
    transform: "translate(-308.37 528.34) rotate(-45)"
  })), _rect475 || (_rect475 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 516.49,
    y: 618.42,
    width: 36,
    height: 36,
    transform: "translate(-293.47 564.34) rotate(-45)"
  })), _rect476 || (_rect476 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 83.74,
    y: 592.97,
    width: 36,
    height: 36,
    transform: "translate(-402.22 250.89) rotate(-45)"
  })), _rect477 || (_rect477 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 134.65,
    y: 592.97,
    width: 36,
    height: 36,
    transform: "translate(-387.31 286.89) rotate(-45)"
  })), _rect478 || (_rect478 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 185.56,
    y: 592.97,
    width: 36,
    height: 36,
    transform: "translate(-372.4 322.89) rotate(-45)"
  })), _rect479 || (_rect479 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 236.48,
    y: 592.97,
    width: 36,
    height: 36,
    transform: "translate(-357.48 358.89) rotate(-45)"
  })), _rect480 || (_rect480 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 287.39,
    y: 592.97,
    width: 36,
    height: 36,
    transform: "translate(-342.57 394.89) rotate(-45)"
  })), _rect481 || (_rect481 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 338.3,
    y: 592.97,
    width: 36,
    height: 36,
    transform: "translate(-327.66 430.89) rotate(-45)"
  })), _rect482 || (_rect482 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 389.21,
    y: 592.97,
    width: 36,
    height: 36,
    transform: "translate(-312.75 466.89) rotate(-45)"
  })), _rect483 || (_rect483 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 440.12,
    y: 592.97,
    width: 36,
    height: 36,
    transform: "translate(-297.84 502.89) rotate(-45)"
  })), _rect484 || (_rect484 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 491.03,
    y: 592.97,
    width: 36,
    height: 36,
    transform: "translate(-282.93 538.89) rotate(-45)"
  })), _rect485 || (_rect485 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 541.95,
    y: 592.97,
    width: 36,
    height: 36,
    transform: "translate(-268.01 574.89) rotate(-45)"
  })), _rect486 || (_rect486 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 32.83,
    y: 643.88,
    width: 36,
    height: 36,
    transform: "translate(-453.13 229.8) rotate(-45)"
  })), _rect487 || (_rect487 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 58.27,
    y: 669.34,
    width: 36,
    height: 36,
    transform: "translate(-463.68 255.25) rotate(-45)"
  })), _rect488 || (_rect488 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 109.2,
    y: 669.33,
    width: 36,
    height: 36,
    transform: "translate(-448.76 291.26) rotate(-45)"
  })), _rect489 || (_rect489 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 160.11,
    y: 669.33,
    width: 36,
    height: 36,
    transform: "translate(-433.85 327.26) rotate(-45)"
  })), _rect490 || (_rect490 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 211.02,
    y: 669.33,
    width: 36,
    height: 36,
    transform: "translate(-418.94 363.26) rotate(-45)"
  })), _rect491 || (_rect491 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 261.93,
    y: 669.33,
    width: 36,
    height: 36,
    transform: "translate(-404.03 399.26) rotate(-45)"
  })), _rect492 || (_rect492 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 312.83,
    y: 669.34,
    width: 36,
    height: 36,
    transform: "translate(-389.12 435.25) rotate(-45)"
  })), _rect493 || (_rect493 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 363.74,
    y: 669.34,
    width: 36,
    height: 36,
    transform: "translate(-374.21 471.25) rotate(-45)"
  })), _rect494 || (_rect494 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 414.67,
    y: 669.33,
    width: 36,
    height: 36,
    transform: "translate(-359.29 507.26) rotate(-45)"
  })), _rect495 || (_rect495 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 465.58,
    y: 669.33,
    width: 36,
    height: 36,
    transform: "translate(-344.38 543.26) rotate(-45)"
  })), _rect496 || (_rect496 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 516.49,
    y: 669.33,
    width: 36,
    height: 36,
    transform: "translate(-329.47 579.26) rotate(-45)"
  })), _rect497 || (_rect497 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 83.74,
    y: 643.88,
    width: 36,
    height: 36,
    transform: "translate(-438.22 265.8) rotate(-45)"
  })), _rect498 || (_rect498 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 134.65,
    y: 643.88,
    width: 36,
    height: 36,
    transform: "translate(-423.31 301.8) rotate(-45)"
  })), _rect499 || (_rect499 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 185.56,
    y: 643.88,
    width: 36,
    height: 36,
    transform: "translate(-408.4 337.8) rotate(-45)"
  })), _rect500 || (_rect500 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP3C",
    x: 236.47,
    y: 643.88,
    width: 36,
    height: 36,
    transform: "translate(-393.48 373.8) rotate(-45)"
  })), _rect501 || (_rect501 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP3C",
    x: 287.39,
    y: 643.88,
    width: 36,
    height: 36,
    transform: "translate(-378.57 409.8) rotate(-45)"
  })), _rect502 || (_rect502 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP3C",
    x: 338.3,
    y: 643.88,
    width: 36,
    height: 36,
    transform: "translate(-363.66 445.8) rotate(-45)"
  })), _rect503 || (_rect503 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 389.21,
    y: 643.88,
    width: 36,
    height: 36,
    transform: "translate(-348.75 481.8) rotate(-45)"
  })), _rect504 || (_rect504 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 440.12,
    y: 643.88,
    width: 36,
    height: 36,
    transform: "translate(-333.84 517.8) rotate(-45)"
  })), _rect505 || (_rect505 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 491.03,
    y: 643.88,
    width: 36,
    height: 36,
    transform: "translate(-318.93 553.8) rotate(-45)"
  })), _rect506 || (_rect506 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 541.94,
    y: 643.88,
    width: 36,
    height: 36,
    transform: "translate(-304.01 589.8) rotate(-45)"
  })), _rect507 || (_rect507 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 32.83,
    y: 694.79,
    width: 36,
    height: 36,
    transform: "translate(-489.13 244.71) rotate(-45)"
  })), _rect508 || (_rect508 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 58.28,
    y: 720.25,
    width: 36,
    height: 36,
    transform: "translate(-499.68 270.17) rotate(-45)"
  })), _rect509 || (_rect509 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 109.21,
    y: 720.25,
    width: 36,
    height: 36,
    transform: "translate(-484.76 306.18) rotate(-45)"
  })), _rect510 || (_rect510 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 160.11,
    y: 720.25,
    width: 36,
    height: 36,
    transform: "translate(-469.85 342.17) rotate(-45)"
  })), _rect511 || (_rect511 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 211.02,
    y: 720.25,
    width: 36,
    height: 36,
    transform: "translate(-454.94 378.17) rotate(-45)"
  })), _rect512 || (_rect512 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 261.93,
    y: 720.25,
    width: 36,
    height: 36,
    transform: "translate(-440.03 414.17) rotate(-45)"
  })), _rect513 || (_rect513 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 312.84,
    y: 720.25,
    width: 36,
    height: 36,
    transform: "translate(-425.12 450.17) rotate(-45)"
  })), _rect514 || (_rect514 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 363.75,
    y: 720.25,
    width: 36,
    height: 36,
    transform: "translate(-410.21 486.17) rotate(-45)"
  })), _rect515 || (_rect515 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 414.68,
    y: 720.25,
    width: 36,
    height: 36,
    transform: "translate(-395.29 522.18) rotate(-45)"
  })), _rect516 || (_rect516 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 465.58,
    y: 720.25,
    width: 36,
    height: 36,
    transform: "translate(-380.38 558.17) rotate(-45)"
  })), _rect517 || (_rect517 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 516.49,
    y: 720.25,
    width: 36,
    height: 36,
    transform: "translate(-365.47 594.17) rotate(-45)"
  })), _rect518 || (_rect518 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 83.74,
    y: 694.79,
    width: 36,
    height: 36,
    transform: "translate(-474.22 280.71) rotate(-45)"
  })), _rect519 || (_rect519 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 134.65,
    y: 694.79,
    width: 36,
    height: 36,
    transform: "translate(-459.31 316.71) rotate(-45)"
  })), _rect520 || (_rect520 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 185.56,
    y: 694.79,
    width: 36,
    height: 36,
    transform: "translate(-444.4 352.71) rotate(-45)"
  })), _rect521 || (_rect521 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 236.47,
    y: 694.79,
    width: 36,
    height: 36,
    transform: "translate(-429.49 388.71) rotate(-45)"
  })), _rect522 || (_rect522 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 287.39,
    y: 694.79,
    width: 36,
    height: 36,
    transform: "translate(-414.57 424.71) rotate(-45)"
  })), _rect523 || (_rect523 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 338.3,
    y: 694.79,
    width: 36,
    height: 36,
    transform: "translate(-399.66 460.71) rotate(-45)"
  })), _rect524 || (_rect524 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 389.21,
    y: 694.79,
    width: 36,
    height: 36,
    transform: "translate(-384.75 496.71) rotate(-45)"
  })), _rect525 || (_rect525 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 440.12,
    y: 694.79,
    width: 36,
    height: 36,
    transform: "translate(-369.84 532.71) rotate(-45)"
  })), _rect526 || (_rect526 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 491.03,
    y: 694.79,
    width: 36,
    height: 36,
    transform: "translate(-354.93 568.71) rotate(-45)"
  })), _rect527 || (_rect527 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 541.94,
    y: 694.78,
    width: 36,
    height: 36,
    transform: "translate(-340.01 604.71) rotate(-45)"
  })), _rect528 || (_rect528 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 32.83,
    y: 745.7,
    width: 36,
    height: 36,
    transform: "translate(-525.13 259.62) rotate(-45)"
  })), _rect529 || (_rect529 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 58.28,
    y: 771.16,
    width: 36,
    height: 36,
    transform: "translate(-535.68 285.08) rotate(-45)"
  })), _rect530 || (_rect530 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 109.2,
    y: 771.17,
    width: 36,
    height: 36,
    transform: "translate(-520.77 321.09) rotate(-45)"
  })), _rect531 || (_rect531 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 160.11,
    y: 771.16,
    width: 36,
    height: 36,
    transform: "translate(-505.85 357.08) rotate(-45)"
  })), _rect532 || (_rect532 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 211.02,
    y: 771.16,
    width: 36,
    height: 36,
    transform: "translate(-490.94 393.08) rotate(-45)"
  })), _rect533 || (_rect533 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP0C",
    x: 261.93,
    y: 771.16,
    width: 36,
    height: 36,
    transform: "translate(-476.03 429.08) rotate(-45)"
  })), _rect534 || (_rect534 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP0C",
    x: 312.84,
    y: 771.16,
    width: 36,
    height: 36,
    transform: "translate(-461.12 465.08) rotate(-45)"
  })), _rect535 || (_rect535 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 363.75,
    y: 771.16,
    width: 36,
    height: 36,
    transform: "translate(-446.21 501.08) rotate(-45)"
  })), _rect536 || (_rect536 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 414.67,
    y: 771.17,
    width: 36,
    height: 36,
    transform: "translate(-431.3 537.09) rotate(-45)"
  })), _rect537 || (_rect537 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 465.58,
    y: 771.16,
    width: 36,
    height: 36,
    transform: "translate(-416.38 573.08) rotate(-45)"
  })), _rect538 || (_rect538 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 516.49,
    y: 771.16,
    width: 36,
    height: 36,
    transform: "translate(-401.47 609.08) rotate(-45)"
  })), _rect539 || (_rect539 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 83.74,
    y: 745.7,
    width: 36,
    height: 36,
    transform: "translate(-510.22 295.62) rotate(-45)"
  })), _rect540 || (_rect540 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP3C",
    x: 134.65,
    y: 745.7,
    width: 36,
    height: 36,
    transform: "translate(-495.31 331.62) rotate(-45)"
  })), _rect541 || (_rect541 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 185.56,
    y: 745.7,
    width: 36,
    height: 36,
    transform: "translate(-480.4 367.62) rotate(-45)"
  })), _rect542 || (_rect542 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 236.46,
    y: 745.71,
    width: 36,
    height: 36,
    transform: "translate(-465.49 403.61) rotate(-45)"
  })), _rect543 || (_rect543 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 287.38,
    y: 745.69,
    width: 36,
    height: 36,
    transform: "translate(-450.56 439.62) rotate(-45)"
  })), _rect544 || (_rect544 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 338.3,
    y: 745.7,
    width: 36,
    height: 36,
    transform: "translate(-435.66 475.62) rotate(-45)"
  })), _rect545 || (_rect545 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 389.21,
    y: 745.7,
    width: 36,
    height: 36,
    transform: "translate(-420.75 511.62) rotate(-45)"
  })), _rect546 || (_rect546 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP3C",
    x: 440.12,
    y: 745.7,
    width: 36,
    height: 36,
    transform: "translate(-405.84 547.62) rotate(-45)"
  })), _rect547 || (_rect547 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 491.03,
    y: 745.7,
    width: 36,
    height: 36,
    transform: "translate(-390.93 583.62) rotate(-45)"
  })), _rect548 || (_rect548 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 541.94,
    y: 745.7,
    width: 36,
    height: 36,
    transform: "translate(-376.01 619.62) rotate(-45)"
  })), _rect549 || (_rect549 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 32.83,
    y: 796.61,
    width: 36,
    height: 36,
    transform: "translate(-561.13 274.54) rotate(-45)"
  })), _rect550 || (_rect550 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 58.28,
    y: 822.07,
    width: 36,
    height: 36,
    transform: "translate(-571.68 299.99) rotate(-45)"
  })), _rect551 || (_rect551 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 109.2,
    y: 822.08,
    width: 36,
    height: 36,
    transform: "translate(-556.77 336) rotate(-45)"
  })), _rect552 || (_rect552 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 160.11,
    y: 822.07,
    width: 36,
    height: 36,
    transform: "translate(-541.85 371.99) rotate(-45)"
  })), _rect553 || (_rect553 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 211.02,
    y: 822.07,
    width: 36,
    height: 36,
    transform: "translate(-526.94 407.99) rotate(-45)"
  })), _rect554 || (_rect554 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP0C",
    x: 261.93,
    y: 822.07,
    width: 36,
    height: 36,
    transform: "translate(-512.03 443.99) rotate(-45)"
  })), _rect555 || (_rect555 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP0C",
    x: 312.84,
    y: 822.07,
    width: 36,
    height: 36,
    transform: "translate(-497.12 479.99) rotate(-45)"
  })), _rect556 || (_rect556 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 363.75,
    y: 822.07,
    width: 36,
    height: 36,
    transform: "translate(-482.21 515.99) rotate(-45)"
  })), _rect557 || (_rect557 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 414.67,
    y: 822.08,
    width: 36,
    height: 36,
    transform: "translate(-467.3 552) rotate(-45)"
  })), _rect558 || (_rect558 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 465.58,
    y: 822.07,
    width: 36,
    height: 36,
    transform: "translate(-452.38 587.99) rotate(-45)"
  })), _rect559 || (_rect559 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 516.49,
    y: 822.07,
    width: 36,
    height: 36,
    transform: "translate(-437.47 623.99) rotate(-45)"
  })), _rect560 || (_rect560 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 83.74,
    y: 796.61,
    width: 36,
    height: 36,
    transform: "translate(-546.22 310.54) rotate(-45)"
  })), _rect561 || (_rect561 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP3C",
    x: 134.65,
    y: 796.61,
    width: 36,
    height: 36,
    transform: "translate(-531.31 346.54) rotate(-45)"
  })), _rect562 || (_rect562 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 185.55,
    y: 796.62,
    width: 36,
    height: 36,
    transform: "translate(-516.4 382.53) rotate(-45)"
  })), _rect563 || (_rect563 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 236.46,
    y: 796.62,
    width: 36,
    height: 36,
    transform: "translate(-501.49 418.53) rotate(-45)"
  })), _rect564 || (_rect564 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP0C",
    x: 287.39,
    y: 796.61,
    width: 36,
    height: 36,
    transform: "translate(-486.57 454.54) rotate(-45)"
  })), _rect565 || (_rect565 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 338.3,
    y: 796.61,
    width: 36,
    height: 36,
    transform: "translate(-471.66 490.54) rotate(-45)"
  })), _rect566 || (_rect566 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 389.21,
    y: 796.61,
    width: 36,
    height: 36,
    transform: "translate(-456.75 526.54) rotate(-45)"
  })), _rect567 || (_rect567 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP3C",
    x: 440.12,
    y: 796.61,
    width: 36,
    height: 36,
    transform: "translate(-441.84 562.54) rotate(-45)"
  })), _rect568 || (_rect568 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 491.02,
    y: 796.62,
    width: 36,
    height: 36,
    transform: "translate(-426.93 598.53) rotate(-45)"
  })), _rect569 || (_rect569 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 541.93,
    y: 796.62,
    width: 36,
    height: 36,
    transform: "translate(-412.02 634.53) rotate(-45)"
  })), _rect570 || (_rect570 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 32.83,
    y: 847.53,
    width: 36,
    height: 36,
    transform: "translate(-597.13 289.45) rotate(-45)"
  })), _rect571 || (_rect571 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 58.28,
    y: 872.98,
    width: 36,
    height: 36,
    transform: "translate(-607.68 314.9) rotate(-45)"
  })), _rect572 || (_rect572 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 109.19,
    y: 872.98,
    width: 36,
    height: 36,
    transform: "translate(-592.76 350.9) rotate(-45)"
  })), _rect573 || (_rect573 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 160.11,
    y: 872.98,
    width: 36,
    height: 36,
    transform: "translate(-577.85 386.9) rotate(-45)"
  })), _rect574 || (_rect574 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 211.02,
    y: 872.98,
    width: 36,
    height: 36,
    transform: "translate(-562.94 422.9) rotate(-45)"
  })), _rect575 || (_rect575 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 261.93,
    y: 872.98,
    width: 36,
    height: 36,
    transform: "translate(-548.03 458.9) rotate(-45)"
  })), _rect576 || (_rect576 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 312.84,
    y: 872.98,
    width: 36,
    height: 36,
    transform: "translate(-533.12 494.9) rotate(-45)"
  })), _rect577 || (_rect577 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 363.75,
    y: 872.98,
    width: 36,
    height: 36,
    transform: "translate(-518.21 530.9) rotate(-45)"
  })), _rect578 || (_rect578 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 414.66,
    y: 872.98,
    width: 36,
    height: 36,
    transform: "translate(-503.29 566.9) rotate(-45)"
  })), _rect579 || (_rect579 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 465.58,
    y: 872.98,
    width: 36,
    height: 36,
    transform: "translate(-488.38 602.9) rotate(-45)"
  })), _rect580 || (_rect580 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 516.49,
    y: 872.98,
    width: 36,
    height: 36,
    transform: "translate(-473.47 638.9) rotate(-45)"
  })), _rect581 || (_rect581 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 83.74,
    y: 847.53,
    width: 36,
    height: 36,
    transform: "translate(-582.22 325.45) rotate(-45)"
  })), _rect582 || (_rect582 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP3C",
    x: 134.65,
    y: 847.53,
    width: 36,
    height: 36,
    transform: "translate(-567.31 361.45) rotate(-45)"
  })), _rect583 || (_rect583 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 185.56,
    y: 847.53,
    width: 36,
    height: 36,
    transform: "translate(-552.4 397.45) rotate(-45)"
  })), _rect584 || (_rect584 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 236.47,
    y: 847.53,
    width: 36,
    height: 36,
    transform: "translate(-537.49 433.45) rotate(-45)"
  })), _rect585 || (_rect585 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 287.4,
    y: 847.52,
    width: 36,
    height: 36,
    transform: "translate(-522.57 469.46) rotate(-45)"
  })), _rect586 || (_rect586 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 338.3,
    y: 847.53,
    width: 36,
    height: 36,
    transform: "translate(-507.66 505.45) rotate(-45)"
  })), _rect587 || (_rect587 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 389.21,
    y: 847.53,
    width: 36,
    height: 36,
    transform: "translate(-492.75 541.45) rotate(-45)"
  })), _rect588 || (_rect588 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP3C",
    x: 440.12,
    y: 847.53,
    width: 36,
    height: 36,
    transform: "translate(-477.84 577.45) rotate(-45)"
  })), _rect589 || (_rect589 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 491.03,
    y: 847.53,
    width: 36,
    height: 36,
    transform: "translate(-462.93 613.45) rotate(-45)"
  })), _rect590 || (_rect590 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 541.94,
    y: 847.53,
    width: 36,
    height: 36,
    transform: "translate(-448.02 649.45) rotate(-45)"
  })), _rect591 || (_rect591 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 32.83,
    y: 898.44,
    width: 36,
    height: 36,
    transform: "translate(-633.13 304.36) rotate(-45)"
  })), _rect592 || (_rect592 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 58.27,
    y: 923.9,
    width: 36,
    height: 36,
    transform: "translate(-643.69 329.81) rotate(-45)"
  })), _rect593 || (_rect593 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 109.2,
    y: 923.89,
    width: 36,
    height: 36,
    transform: "translate(-628.76 365.82) rotate(-45)"
  })), _rect594 || (_rect594 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 160.11,
    y: 923.89,
    width: 36,
    height: 36,
    transform: "translate(-613.85 401.82) rotate(-45)"
  })), _rect595 || (_rect595 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 211.03,
    y: 923.9,
    width: 36,
    height: 36,
    transform: "translate(-598.95 437.82) rotate(-45)"
  })), _rect596 || (_rect596 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 261.93,
    y: 923.89,
    width: 36,
    height: 36,
    transform: "translate(-584.03 473.82) rotate(-45)"
  })), _rect597 || (_rect597 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 312.84,
    y: 923.89,
    width: 36,
    height: 36,
    transform: "translate(-569.12 509.82) rotate(-45)"
  })), _rect598 || (_rect598 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 363.74,
    y: 923.9,
    width: 36,
    height: 36,
    transform: "translate(-554.22 545.81) rotate(-45)"
  })), _rect599 || (_rect599 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 414.67,
    y: 923.89,
    width: 36,
    height: 36,
    transform: "translate(-539.29 581.82) rotate(-45)"
  })), _rect600 || (_rect600 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 465.58,
    y: 923.89,
    width: 36,
    height: 36,
    transform: "translate(-524.38 617.82) rotate(-45)"
  })), _rect601 || (_rect601 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 516.5,
    y: 923.9,
    width: 36,
    height: 36,
    transform: "translate(-509.48 653.82) rotate(-45)"
  })), _rect602 || (_rect602 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 83.74,
    y: 898.44,
    width: 36,
    height: 36,
    transform: "translate(-618.22 340.36) rotate(-45)"
  })), _rect603 || (_rect603 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 134.65,
    y: 898.44,
    width: 36,
    height: 36,
    transform: "translate(-603.31 376.36) rotate(-45)"
  })), _rect604 || (_rect604 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 185.56,
    y: 898.44,
    width: 36,
    height: 36,
    transform: "translate(-588.4 412.36) rotate(-45)"
  })), _rect605 || (_rect605 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 236.47,
    y: 898.44,
    width: 36,
    height: 36,
    transform: "translate(-573.49 448.36) rotate(-45)"
  })), _rect606 || (_rect606 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 287.39,
    y: 898.44,
    width: 36,
    height: 36,
    transform: "translate(-558.57 484.36) rotate(-45)"
  })), _rect607 || (_rect607 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 338.3,
    y: 898.44,
    width: 36,
    height: 36,
    transform: "translate(-543.66 520.36) rotate(-45)"
  })), _rect608 || (_rect608 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 389.21,
    y: 898.44,
    width: 36,
    height: 36,
    transform: "translate(-528.75 556.36) rotate(-45)"
  })), _rect609 || (_rect609 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 440.12,
    y: 898.44,
    width: 36,
    height: 36,
    transform: "translate(-513.84 592.36) rotate(-45)"
  })), _rect610 || (_rect610 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 491.03,
    y: 898.44,
    width: 36,
    height: 36,
    transform: "translate(-498.93 628.36) rotate(-45)"
  })), _rect611 || (_rect611 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 541.94,
    y: 898.44,
    width: 36,
    height: 36,
    transform: "translate(-484.02 664.36) rotate(-45)"
  })), _rect612 || (_rect612 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 32.83,
    y: 949.35,
    width: 36,
    height: 36,
    transform: "translate(-669.13 319.27) rotate(-45)"
  })), _rect613 || (_rect613 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 58.28,
    y: 974.81,
    width: 36,
    height: 36,
    transform: "translate(-679.68 344.73) rotate(-45)"
  })), _rect614 || (_rect614 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 109.2,
    y: 974.81,
    width: 36,
    height: 36,
    transform: "translate(-664.77 380.73) rotate(-45)"
  })), _rect615 || (_rect615 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 160.12,
    y: 974.8,
    width: 36,
    height: 36,
    transform: "translate(-649.85 416.74) rotate(-45)"
  })), _rect616 || (_rect616 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 211.02,
    y: 974.81,
    width: 36,
    height: 36,
    transform: "translate(-634.94 452.73) rotate(-45)"
  })), _rect617 || (_rect617 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 261.93,
    y: 974.81,
    width: 36,
    height: 36,
    transform: "translate(-620.03 488.73) rotate(-45)"
  })), _rect618 || (_rect618 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 312.84,
    y: 974.81,
    width: 36,
    height: 36,
    transform: "translate(-605.12 524.73) rotate(-45)"
  })), _rect619 || (_rect619 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 363.75,
    y: 974.81,
    width: 36,
    height: 36,
    transform: "translate(-590.21 560.73) rotate(-45)"
  })), _rect620 || (_rect620 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 414.68,
    y: 974.81,
    width: 36,
    height: 36,
    transform: "translate(-575.29 596.74) rotate(-45)"
  })), _rect621 || (_rect621 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 465.59,
    y: 974.8,
    width: 36,
    height: 36,
    transform: "translate(-560.38 632.74) rotate(-45)"
  })), _rect622 || (_rect622 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 516.49,
    y: 974.81,
    width: 36,
    height: 36,
    transform: "translate(-545.47 668.73) rotate(-45)"
  })), _rect623 || (_rect623 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 83.74,
    y: 949.35,
    width: 36,
    height: 36,
    transform: "translate(-654.22 355.27) rotate(-45)"
  })), _rect624 || (_rect624 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 134.65,
    y: 949.35,
    width: 36,
    height: 36,
    transform: "translate(-639.31 391.27) rotate(-45)"
  })), _rect625 || (_rect625 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 185.56,
    y: 949.35,
    width: 36,
    height: 36,
    transform: "translate(-624.4 427.27) rotate(-45)"
  })), _rect626 || (_rect626 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP3C",
    x: 236.47,
    y: 949.35,
    width: 36,
    height: 36,
    transform: "translate(-609.49 463.27) rotate(-45)"
  })), _rect627 || (_rect627 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP3C",
    x: 287.39,
    y: 949.35,
    width: 36,
    height: 36,
    transform: "translate(-594.57 499.27) rotate(-45)"
  })), _rect628 || (_rect628 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP3C",
    x: 338.3,
    y: 949.35,
    width: 36,
    height: 36,
    transform: "translate(-579.66 535.27) rotate(-45)"
  })), _rect629 || (_rect629 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 389.21,
    y: 949.35,
    width: 36,
    height: 36,
    transform: "translate(-564.75 571.27) rotate(-45)"
  })), _rect630 || (_rect630 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 440.12,
    y: 949.35,
    width: 36,
    height: 36,
    transform: "translate(-549.84 607.27) rotate(-45)"
  })), _rect631 || (_rect631 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 491.03,
    y: 949.35,
    width: 36,
    height: 36,
    transform: "translate(-534.93 643.27) rotate(-45)"
  })), _rect632 || (_rect632 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 541.94,
    y: 949.35,
    width: 36,
    height: 36,
    transform: "translate(-520.02 679.27) rotate(-45)"
  })), _rect633 || (_rect633 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 32.83,
    y: 1000.26,
    width: 36,
    height: 36,
    transform: "translate(-705.13 334.18) rotate(-45)"
  })), _rect634 || (_rect634 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 58.28,
    y: 1025.72,
    width: 36,
    height: 36,
    transform: "translate(-715.68 359.64) rotate(-45)"
  })), _rect635 || (_rect635 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 109.2,
    y: 1025.72,
    width: 36,
    height: 36,
    transform: "translate(-700.77 395.64) rotate(-45)"
  })), _rect636 || (_rect636 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 160.11,
    y: 1025.72,
    width: 36,
    height: 36,
    transform: "translate(-685.85 431.64) rotate(-45)"
  })), _rect637 || (_rect637 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 211.02,
    y: 1025.72,
    width: 36,
    height: 36,
    transform: "translate(-670.94 467.64) rotate(-45)"
  })), _rect638 || (_rect638 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 261.93,
    y: 1025.72,
    width: 36,
    height: 36,
    transform: "translate(-656.03 503.64) rotate(-45)"
  })), _rect639 || (_rect639 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 312.84,
    y: 1025.72,
    width: 36,
    height: 36,
    transform: "translate(-641.12 539.64) rotate(-45)"
  })), _rect640 || (_rect640 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 363.75,
    y: 1025.72,
    width: 36,
    height: 36,
    transform: "translate(-626.21 575.64) rotate(-45)"
  })), _rect641 || (_rect641 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 414.68,
    y: 1025.72,
    width: 36,
    height: 36,
    transform: "translate(-611.29 611.65) rotate(-45)"
  })), _rect642 || (_rect642 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 465.58,
    y: 1025.72,
    width: 36,
    height: 36,
    transform: "translate(-596.38 647.64) rotate(-45)"
  })), _rect643 || (_rect643 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 516.49,
    y: 1025.72,
    width: 36,
    height: 36,
    transform: "translate(-581.47 683.64) rotate(-45)"
  })), _rect644 || (_rect644 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 83.74,
    y: 1000.26,
    width: 36,
    height: 36,
    transform: "translate(-690.22 370.18) rotate(-45)"
  })), _rect645 || (_rect645 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 134.65,
    y: 1000.26,
    width: 36,
    height: 36,
    transform: "translate(-675.31 406.18) rotate(-45)"
  })), _rect646 || (_rect646 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 185.56,
    y: 1000.26,
    width: 36,
    height: 36,
    transform: "translate(-660.4 442.18) rotate(-45)"
  })), _rect647 || (_rect647 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 236.47,
    y: 1000.26,
    width: 36,
    height: 36,
    transform: "translate(-645.49 478.18) rotate(-45)"
  })), _rect648 || (_rect648 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 287.39,
    y: 1000.26,
    width: 36,
    height: 36,
    transform: "translate(-630.57 514.18) rotate(-45)"
  })), _rect649 || (_rect649 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 338.3,
    y: 1000.26,
    width: 36,
    height: 36,
    transform: "translate(-615.66 550.18) rotate(-45)"
  })), _rect650 || (_rect650 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 389.21,
    y: 1000.26,
    width: 36,
    height: 36,
    transform: "translate(-600.75 586.18) rotate(-45)"
  })), _rect651 || (_rect651 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 440.12,
    y: 1000.26,
    width: 36,
    height: 36,
    transform: "translate(-585.84 622.18) rotate(-45)"
  })), _rect652 || (_rect652 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 491.03,
    y: 1000.26,
    width: 36,
    height: 36,
    transform: "translate(-570.93 658.18) rotate(-45)"
  })), _rect653 || (_rect653 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 541.94,
    y: 1000.26,
    width: 36,
    height: 36,
    transform: "translate(-556.02 694.18) rotate(-45)"
  })), _rect654 || (_rect654 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 32.83,
    y: 1051.17,
    width: 36,
    height: 36,
    transform: "translate(-741.13 349.09) rotate(-45)"
  })), _rect655 || (_rect655 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 83.74,
    y: 1051.17,
    width: 36,
    height: 36,
    transform: "translate(-726.22 385.09) rotate(-45)"
  })), _rect656 || (_rect656 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 134.65,
    y: 1051.17,
    width: 36,
    height: 36,
    transform: "translate(-711.31 421.09) rotate(-45)"
  })), _rect657 || (_rect657 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 185.56,
    y: 1051.17,
    width: 36,
    height: 36,
    transform: "translate(-696.4 457.09) rotate(-45)"
  })), _rect658 || (_rect658 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 236.46,
    y: 1051.18,
    width: 36,
    height: 36,
    transform: "translate(-681.49 493.08) rotate(-45)"
  })), _rect659 || (_rect659 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 287.38,
    y: 1051.16,
    width: 36,
    height: 36,
    transform: "translate(-666.56 529.09) rotate(-45)"
  })), _rect660 || (_rect660 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 338.3,
    y: 1051.17,
    width: 36,
    height: 36,
    transform: "translate(-651.66 565.09) rotate(-45)"
  })), _rect661 || (_rect661 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 389.21,
    y: 1051.17,
    width: 36,
    height: 36,
    transform: "translate(-636.75 601.09) rotate(-45)"
  })), _rect662 || (_rect662 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 440.12,
    y: 1051.17,
    width: 36,
    height: 36,
    transform: "translate(-621.84 637.09) rotate(-45)"
  })), _rect663 || (_rect663 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 491.03,
    y: 1051.17,
    width: 36,
    height: 36,
    transform: "translate(-606.93 673.09) rotate(-45)"
  })), _rect664 || (_rect664 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 541.93,
    y: 1051.18,
    width: 36,
    height: 36,
    transform: "translate(-592.02 709.08) rotate(-45)"
  })), _rect665 || (_rect665 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 542.06,
    y: 542.05,
    width: 36,
    height: 36,
    transform: "translate(-231.98 560.06) rotate(-45)"
  })), _rect666 || (_rect666 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 567.51,
    y: 567.51,
    width: 36,
    height: 36,
    transform: "translate(-242.53 585.51) rotate(-45)"
  })), _rect667 || (_rect667 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 618.42,
    y: 567.51,
    width: 36,
    height: 36,
    transform: "translate(-227.61 621.51) rotate(-45)"
  })), _rect668 || (_rect668 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 669.33,
    y: 567.51,
    width: 36,
    height: 36,
    transform: "translate(-212.7 657.51) rotate(-45)"
  })), _rect669 || (_rect669 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 720.25,
    y: 567.51,
    width: 36,
    height: 36,
    transform: "translate(-197.79 693.51) rotate(-45)"
  })), _rect670 || (_rect670 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 771.16,
    y: 567.51,
    width: 36,
    height: 36,
    transform: "translate(-182.88 729.51) rotate(-45)"
  })), _rect671 || (_rect671 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 822.07,
    y: 567.51,
    width: 36,
    height: 36,
    transform: "translate(-167.97 765.51) rotate(-45)"
  })), _rect672 || (_rect672 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 872.98,
    y: 567.51,
    width: 36,
    height: 36,
    transform: "translate(-153.06 801.51) rotate(-45)"
  })), _rect673 || (_rect673 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 923.89,
    y: 567.51,
    width: 36,
    height: 36,
    transform: "translate(-138.14 837.51) rotate(-45)"
  })), _rect674 || (_rect674 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 974.8,
    y: 567.51,
    width: 36,
    height: 36,
    transform: "translate(-123.23 873.51) rotate(-45)"
  })), _rect675 || (_rect675 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 1025.72,
    y: 567.51,
    width: 36,
    height: 36,
    transform: "translate(-108.32 909.51) rotate(-45)"
  })), _rect676 || (_rect676 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 592.97,
    y: 542.04,
    width: 36,
    height: 36,
    transform: "translate(-217.06 596.05) rotate(-45)"
  })), _rect677 || (_rect677 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 643.87,
    y: 542.06,
    width: 36,
    height: 36,
    transform: "translate(-202.16 632.05) rotate(-45)"
  })), _rect678 || (_rect678 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 694.78,
    y: 542.06,
    width: 36,
    height: 36,
    transform: "translate(-187.25 668.05) rotate(-45)"
  })), _rect679 || (_rect679 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 745.69,
    y: 542.06,
    width: 36,
    height: 36,
    transform: "translate(-172.34 704.05) rotate(-45)"
  })), _rect680 || (_rect680 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 796.61,
    y: 542.06,
    width: 36,
    height: 36,
    transform: "translate(-157.43 740.05) rotate(-45)"
  })), _rect681 || (_rect681 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 847.53,
    y: 542.05,
    width: 36,
    height: 36,
    transform: "translate(-142.51 776.06) rotate(-45)"
  })), _rect682 || (_rect682 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 898.44,
    y: 542.04,
    width: 36,
    height: 36,
    transform: "translate(-127.59 812.05) rotate(-45)"
  })), _rect683 || (_rect683 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 949.34,
    y: 542.06,
    width: 36,
    height: 36,
    transform: "translate(-112.69 848.05) rotate(-45)"
  })), _rect684 || (_rect684 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 1000.25,
    y: 542.06,
    width: 36,
    height: 36,
    transform: "translate(-97.78 884.05) rotate(-45)"
  })), _rect685 || (_rect685 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 1051.17,
    y: 542.06,
    width: 36,
    height: 36,
    transform: "translate(-82.87 920.06) rotate(-45)"
  })), _rect686 || (_rect686 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 542.06,
    y: 592.97,
    width: 36,
    height: 36,
    transform: "translate(-267.98 574.97) rotate(-45)"
  })), _rect687 || (_rect687 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 567.5,
    y: 618.43,
    width: 36,
    height: 36,
    transform: "translate(-278.53 600.41) rotate(-45)"
  })), _rect688 || (_rect688 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 618.42,
    y: 618.42,
    width: 36,
    height: 36,
    transform: "translate(-263.61 636.42) rotate(-45)"
  })), _rect689 || (_rect689 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 669.33,
    y: 618.42,
    width: 36,
    height: 36,
    transform: "translate(-248.7 672.42) rotate(-45)"
  })), _rect690 || (_rect690 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 720.25,
    y: 618.42,
    width: 36,
    height: 36,
    transform: "translate(-233.79 708.42) rotate(-45)"
  })), _rect691 || (_rect691 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 771.16,
    y: 618.42,
    width: 36,
    height: 36,
    transform: "translate(-218.88 744.42) rotate(-45)"
  })), _rect692 || (_rect692 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 822.07,
    y: 618.42,
    width: 36,
    height: 36,
    transform: "translate(-203.97 780.42) rotate(-45)"
  })), _rect693 || (_rect693 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 872.97,
    y: 618.43,
    width: 36,
    height: 36,
    transform: "translate(-189.06 816.41) rotate(-45)"
  })), _rect694 || (_rect694 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 923.89,
    y: 618.42,
    width: 36,
    height: 36,
    transform: "translate(-174.14 852.42) rotate(-45)"
  })), _rect695 || (_rect695 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 974.8,
    y: 618.42,
    width: 36,
    height: 36,
    transform: "translate(-159.23 888.42) rotate(-45)"
  })), _rect696 || (_rect696 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 1025.72,
    y: 618.42,
    width: 36,
    height: 36,
    transform: "translate(-144.32 924.42) rotate(-45)"
  })), _rect697 || (_rect697 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 592.97,
    y: 592.97,
    width: 36,
    height: 36,
    transform: "translate(-253.07 610.97) rotate(-45)"
  })), _rect698 || (_rect698 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 643.88,
    y: 592.97,
    width: 36,
    height: 36,
    transform: "translate(-238.16 646.97) rotate(-45)"
  })), _rect699 || (_rect699 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 694.79,
    y: 592.97,
    width: 36,
    height: 36,
    transform: "translate(-223.25 682.97) rotate(-45)"
  })), _rect700 || (_rect700 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 745.7,
    y: 592.97,
    width: 36,
    height: 36,
    transform: "translate(-208.34 718.97) rotate(-45)"
  })), _rect701 || (_rect701 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP0C",
    x: 796.61,
    y: 592.97,
    width: 36,
    height: 36,
    transform: "translate(-193.42 754.97) rotate(-45)"
  })), _rect702 || (_rect702 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 847.53,
    y: 592.97,
    width: 36,
    height: 36,
    transform: "translate(-178.51 790.97) rotate(-45)"
  })), _rect703 || (_rect703 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 898.44,
    y: 592.97,
    width: 36,
    height: 36,
    transform: "translate(-163.6 826.97) rotate(-45)"
  })), _rect704 || (_rect704 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 949.35,
    y: 592.97,
    width: 36,
    height: 36,
    transform: "translate(-148.69 862.97) rotate(-45)"
  })), _rect705 || (_rect705 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 1000.26,
    y: 592.97,
    width: 36,
    height: 36,
    transform: "translate(-133.78 898.97) rotate(-45)"
  })), _rect706 || (_rect706 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 1051.17,
    y: 592.97,
    width: 36,
    height: 36,
    transform: "translate(-118.87 934.97) rotate(-45)"
  })), _rect707 || (_rect707 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 542.06,
    y: 643.88,
    width: 36,
    height: 36,
    transform: "translate(-303.98 589.88) rotate(-45)"
  })), _rect708 || (_rect708 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 567.51,
    y: 669.33,
    width: 36,
    height: 36,
    transform: "translate(-314.53 615.33) rotate(-45)"
  })), _rect709 || (_rect709 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 618.42,
    y: 669.33,
    width: 36,
    height: 36,
    transform: "translate(-299.61 651.33) rotate(-45)"
  })), _rect710 || (_rect710 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 669.33,
    y: 669.33,
    width: 36,
    height: 36,
    transform: "translate(-284.7 687.33) rotate(-45)"
  })), _rect711 || (_rect711 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 720.25,
    y: 669.32,
    width: 36,
    height: 36,
    transform: "translate(-269.78 723.33) rotate(-45)"
  })), _rect712 || (_rect712 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 771.17,
    y: 669.33,
    width: 36,
    height: 36,
    transform: "translate(-254.87 759.34) rotate(-45)"
  })), _rect713 || (_rect713 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 822.06,
    y: 669.34,
    width: 36,
    height: 36,
    transform: "translate(-239.97 795.33) rotate(-45)"
  })), _rect714 || (_rect714 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 872.97,
    y: 669.34,
    width: 36,
    height: 36,
    transform: "translate(-225.06 831.33) rotate(-45)"
  })), _rect715 || (_rect715 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 923.89,
    y: 669.35,
    width: 36,
    height: 36,
    transform: "translate(-210.15 867.34) rotate(-45)"
  })), _rect716 || (_rect716 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 974.8,
    y: 669.34,
    width: 36,
    height: 36,
    transform: "translate(-195.24 903.33) rotate(-45)"
  })), _rect717 || (_rect717 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 1025.72,
    y: 669.33,
    width: 36,
    height: 36,
    transform: "translate(-180.32 939.34) rotate(-45)"
  })), _rect718 || (_rect718 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 592.97,
    y: 643.88,
    width: 36,
    height: 36,
    transform: "translate(-289.07 625.88) rotate(-45)"
  })), _rect719 || (_rect719 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 643.88,
    y: 643.88,
    width: 36,
    height: 36,
    transform: "translate(-274.16 661.88) rotate(-45)"
  })), _rect720 || (_rect720 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 694.79,
    y: 643.88,
    width: 36,
    height: 36,
    transform: "translate(-259.25 697.88) rotate(-45)"
  })), _rect721 || (_rect721 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 745.7,
    y: 643.88,
    width: 36,
    height: 36,
    transform: "translate(-244.34 733.88) rotate(-45)"
  })), _rect722 || (_rect722 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP0C",
    x: 796.61,
    y: 643.88,
    width: 36,
    height: 36,
    transform: "translate(-229.42 769.88) rotate(-45)"
  })), _rect723 || (_rect723 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 847.53,
    y: 643.88,
    width: 36,
    height: 36,
    transform: "translate(-214.51 805.88) rotate(-45)"
  })), _rect724 || (_rect724 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 898.44,
    y: 643.88,
    width: 36,
    height: 36,
    transform: "translate(-199.6 841.88) rotate(-45)"
  })), _rect725 || (_rect725 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 949.35,
    y: 643.88,
    width: 36,
    height: 36,
    transform: "translate(-184.69 877.88) rotate(-45)"
  })), _rect726 || (_rect726 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 1000.26,
    y: 643.88,
    width: 36,
    height: 36,
    transform: "translate(-169.78 913.88) rotate(-45)"
  })), _rect727 || (_rect727 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 1051.17,
    y: 643.88,
    width: 36,
    height: 36,
    transform: "translate(-154.87 949.88) rotate(-45)"
  })), _rect728 || (_rect728 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 542.06,
    y: 694.79,
    width: 36,
    height: 36,
    transform: "translate(-339.98 604.79) rotate(-45)"
  })), _rect729 || (_rect729 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 567.51,
    y: 720.25,
    width: 36,
    height: 36,
    transform: "translate(-350.53 630.25) rotate(-45)"
  })), _rect730 || (_rect730 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 618.43,
    y: 720.25,
    width: 36,
    height: 36,
    transform: "translate(-335.62 666.25) rotate(-45)"
  })), _rect731 || (_rect731 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 669.34,
    y: 720.26,
    width: 36,
    height: 36,
    transform: "translate(-320.71 702.25) rotate(-45)"
  })), _rect732 || (_rect732 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 720.25,
    y: 720.25,
    width: 36,
    height: 36,
    transform: "translate(-305.79 738.25) rotate(-45)"
  })), _rect733 || (_rect733 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 771.16,
    y: 720.25,
    width: 36,
    height: 36,
    transform: "translate(-290.88 774.25) rotate(-45)"
  })), _rect734 || (_rect734 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 822.07,
    y: 720.25,
    width: 36,
    height: 36,
    transform: "translate(-275.97 810.25) rotate(-45)"
  })), _rect735 || (_rect735 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 872.98,
    y: 720.25,
    width: 36,
    height: 36,
    transform: "translate(-261.06 846.25) rotate(-45)"
  })), _rect736 || (_rect736 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 923.9,
    y: 720.25,
    width: 36,
    height: 36,
    transform: "translate(-246.15 882.25) rotate(-45)"
  })), _rect737 || (_rect737 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 974.81,
    y: 720.26,
    width: 36,
    height: 36,
    transform: "translate(-231.24 918.25) rotate(-45)"
  })), _rect738 || (_rect738 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 1025.72,
    y: 720.25,
    width: 36,
    height: 36,
    transform: "translate(-216.32 954.25) rotate(-45)"
  })), _rect739 || (_rect739 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 592.97,
    y: 694.79,
    width: 36,
    height: 36,
    transform: "translate(-325.07 640.79) rotate(-45)"
  })), _rect740 || (_rect740 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 643.88,
    y: 694.79,
    width: 36,
    height: 36,
    transform: "translate(-310.16 676.79) rotate(-45)"
  })), _rect741 || (_rect741 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 694.79,
    y: 694.79,
    width: 36,
    height: 36,
    transform: "translate(-295.25 712.79) rotate(-45)"
  })), _rect742 || (_rect742 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 745.7,
    y: 694.79,
    width: 36,
    height: 36,
    transform: "translate(-280.34 748.79) rotate(-45)"
  })), _rect743 || (_rect743 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP0C",
    x: 796.6,
    y: 694.79,
    width: 36,
    height: 36,
    transform: "translate(-265.43 784.78) rotate(-45)"
  })), _rect744 || (_rect744 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 847.53,
    y: 694.79,
    width: 36,
    height: 36,
    transform: "translate(-250.51 820.79) rotate(-45)"
  })), _rect745 || (_rect745 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 898.44,
    y: 694.79,
    width: 36,
    height: 36,
    transform: "translate(-235.6 856.79) rotate(-45)"
  })), _rect746 || (_rect746 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 949.35,
    y: 694.79,
    width: 36,
    height: 36,
    transform: "translate(-220.69 892.79) rotate(-45)"
  })), _rect747 || (_rect747 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 1000.26,
    y: 694.79,
    width: 36,
    height: 36,
    transform: "translate(-205.78 928.79) rotate(-45)"
  })), _rect748 || (_rect748 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 1051.17,
    y: 694.79,
    width: 36,
    height: 36,
    transform: "translate(-190.87 964.79) rotate(-45)"
  })), _rect749 || (_rect749 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 542.06,
    y: 745.7,
    width: 36,
    height: 36,
    transform: "translate(-375.98 619.7) rotate(-45)"
  })), _rect750 || (_rect750 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 567.51,
    y: 771.16,
    width: 36,
    height: 36,
    transform: "translate(-386.53 645.16) rotate(-45)"
  })), _rect751 || (_rect751 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 618.42,
    y: 771.16,
    width: 36,
    height: 36,
    transform: "translate(-371.62 681.16) rotate(-45)"
  })), _rect752 || (_rect752 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 669.33,
    y: 771.16,
    width: 36,
    height: 36,
    transform: "translate(-356.7 717.16) rotate(-45)"
  })), _rect753 || (_rect753 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 720.25,
    y: 771.16,
    width: 36,
    height: 36,
    transform: "translate(-341.79 753.16) rotate(-45)"
  })), _rect754 || (_rect754 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 771.16,
    y: 771.16,
    width: 36,
    height: 36,
    transform: "translate(-326.88 789.16) rotate(-45)"
  })), _rect755 || (_rect755 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 822.07,
    y: 771.16,
    width: 36,
    height: 36,
    transform: "translate(-311.97 825.16) rotate(-45)"
  })), _rect756 || (_rect756 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 872.98,
    y: 771.16,
    width: 36,
    height: 36,
    transform: "translate(-297.06 861.16) rotate(-45)"
  })), _rect757 || (_rect757 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 923.89,
    y: 771.16,
    width: 36,
    height: 36,
    transform: "translate(-282.14 897.16) rotate(-45)"
  })), _rect758 || (_rect758 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 974.8,
    y: 771.16,
    width: 36,
    height: 36,
    transform: "translate(-267.23 933.16) rotate(-45)"
  })), _rect759 || (_rect759 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 1025.72,
    y: 771.16,
    width: 36,
    height: 36,
    transform: "translate(-252.32 969.16) rotate(-45)"
  })), _rect760 || (_rect760 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 592.97,
    y: 745.7,
    width: 36,
    height: 36,
    transform: "translate(-361.07 655.7) rotate(-45)"
  })), _rect761 || (_rect761 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 643.88,
    y: 745.7,
    width: 36,
    height: 36,
    transform: "translate(-346.16 691.7) rotate(-45)"
  })), _rect762 || (_rect762 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 694.79,
    y: 745.7,
    width: 36,
    height: 36,
    transform: "translate(-331.25 727.7) rotate(-45)"
  })), _rect763 || (_rect763 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 745.69,
    y: 745.71,
    width: 36,
    height: 36,
    transform: "translate(-316.34 763.69) rotate(-45)"
  })), _rect764 || (_rect764 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 796.61,
    y: 745.7,
    width: 36,
    height: 36,
    transform: "translate(-301.42 799.7) rotate(-45)"
  })), _rect765 || (_rect765 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 847.53,
    y: 745.7,
    width: 36,
    height: 36,
    transform: "translate(-286.51 835.7) rotate(-45)"
  })), _rect766 || (_rect766 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 898.44,
    y: 745.7,
    width: 36,
    height: 36,
    transform: "translate(-271.6 871.7) rotate(-45)"
  })), _rect767 || (_rect767 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 949.35,
    y: 745.7,
    width: 36,
    height: 36,
    transform: "translate(-256.69 907.7) rotate(-45)"
  })), _rect768 || (_rect768 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 1000.26,
    y: 745.7,
    width: 36,
    height: 36,
    transform: "translate(-241.78 943.7) rotate(-45)"
  })), _rect769 || (_rect769 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 1051.16,
    y: 745.71,
    width: 36,
    height: 36,
    transform: "translate(-226.87 979.69) rotate(-45)"
  })), _rect770 || (_rect770 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 542.06,
    y: 796.6,
    width: 36,
    height: 36,
    transform: "translate(-411.97 634.61) rotate(-45)"
  })), _rect771 || (_rect771 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 567.51,
    y: 822.07,
    width: 36,
    height: 36,
    transform: "translate(-422.53 660.07) rotate(-45)"
  })), _rect772 || (_rect772 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 618.42,
    y: 822.07,
    width: 36,
    height: 36,
    transform: "translate(-407.62 696.07) rotate(-45)"
  })), _rect773 || (_rect773 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 669.32,
    y: 822.07,
    width: 36,
    height: 36,
    transform: "translate(-392.71 732.06) rotate(-45)"
  })), _rect774 || (_rect774 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 720.25,
    y: 822.07,
    width: 36,
    height: 36,
    transform: "translate(-377.79 768.07) rotate(-45)"
  })), _rect775 || (_rect775 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 771.16,
    y: 822.07,
    width: 36,
    height: 36,
    transform: "translate(-362.88 804.07) rotate(-45)"
  })), _rect776 || (_rect776 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 822.07,
    y: 822.07,
    width: 36,
    height: 36,
    transform: "translate(-347.97 840.07) rotate(-45)"
  })), _rect777 || (_rect777 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 872.98,
    y: 822.07,
    width: 36,
    height: 36,
    transform: "translate(-333.06 876.07) rotate(-45)"
  })), _rect778 || (_rect778 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 923.89,
    y: 822.07,
    width: 36,
    height: 36,
    transform: "translate(-318.14 912.07) rotate(-45)"
  })), _rect779 || (_rect779 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 974.79,
    y: 822.07,
    width: 36,
    height: 36,
    transform: "translate(-303.24 948.06) rotate(-45)"
  })), _rect780 || (_rect780 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 1025.72,
    y: 822.07,
    width: 36,
    height: 36,
    transform: "translate(-288.32 984.07) rotate(-45)"
  })), _rect781 || (_rect781 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP0C",
    x: 592.98,
    y: 796.61,
    width: 36,
    height: 36,
    transform: "translate(-397.06 670.62) rotate(-45)"
  })), _rect782 || (_rect782 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP0C",
    x: 643.89,
    y: 796.61,
    width: 36,
    height: 36,
    transform: "translate(-382.15 706.62) rotate(-45)"
  })), _rect783 || (_rect783 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP0C",
    x: 694.79,
    y: 796.61,
    width: 36,
    height: 36,
    transform: "translate(-367.25 742.61) rotate(-45)"
  })), _rect784 || (_rect784 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 745.7,
    y: 796.62,
    width: 36,
    height: 36,
    transform: "translate(-352.34 778.61) rotate(-45)"
  })), _rect785 || (_rect785 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP4C",
    x: 796.61,
    y: 796.61,
    width: 36,
    height: 36,
    transform: "translate(-337.42 814.61) rotate(-45)"
  })), _rect786 || (_rect786 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 847.53,
    y: 796.6,
    width: 36,
    height: 36,
    transform: "translate(-322.5 850.61) rotate(-45)"
  })), _rect787 || (_rect787 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP0C",
    x: 898.45,
    y: 796.61,
    width: 36,
    height: 36,
    transform: "translate(-307.59 886.62) rotate(-45)"
  })), _rect788 || (_rect788 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP0C",
    x: 949.36,
    y: 796.61,
    width: 36,
    height: 36,
    transform: "translate(-292.68 922.62) rotate(-45)"
  })), _rect789 || (_rect789 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP0C",
    x: 1000.26,
    y: 796.61,
    width: 36,
    height: 36,
    transform: "translate(-277.78 958.61) rotate(-45)"
  })), _rect790 || (_rect790 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 1051.17,
    y: 796.62,
    width: 36,
    height: 36,
    transform: "translate(-262.87 994.61) rotate(-45)"
  })), _rect791 || (_rect791 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 542.06,
    y: 847.53,
    width: 36,
    height: 36,
    transform: "translate(-447.98 649.53) rotate(-45)"
  })), _rect792 || (_rect792 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 567.51,
    y: 872.98,
    width: 36,
    height: 36,
    transform: "translate(-458.53 674.98) rotate(-45)"
  })), _rect793 || (_rect793 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 618.41,
    y: 872.99,
    width: 36,
    height: 36,
    transform: "translate(-443.62 710.97) rotate(-45)"
  })), _rect794 || (_rect794 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 669.33,
    y: 872.98,
    width: 36,
    height: 36,
    transform: "translate(-428.7 746.98) rotate(-45)"
  })), _rect795 || (_rect795 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 720.25,
    y: 872.98,
    width: 36,
    height: 36,
    transform: "translate(-413.79 782.98) rotate(-45)"
  })), _rect796 || (_rect796 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 771.16,
    y: 872.98,
    width: 36,
    height: 36,
    transform: "translate(-398.88 818.98) rotate(-45)"
  })), _rect797 || (_rect797 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 822.07,
    y: 872.98,
    width: 36,
    height: 36,
    transform: "translate(-383.97 854.98) rotate(-45)"
  })), _rect798 || (_rect798 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 872.98,
    y: 872.98,
    width: 36,
    height: 36,
    transform: "translate(-369.06 890.98) rotate(-45)"
  })), _rect799 || (_rect799 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 923.88,
    y: 872.99,
    width: 36,
    height: 36,
    transform: "translate(-354.15 926.97) rotate(-45)"
  })), _rect800 || (_rect800 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 974.8,
    y: 872.98,
    width: 36,
    height: 36,
    transform: "translate(-339.23 962.98) rotate(-45)"
  })), _rect801 || (_rect801 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 1025.72,
    y: 872.98,
    width: 36,
    height: 36,
    transform: "translate(-324.32 998.98) rotate(-45)"
  })), _rect802 || (_rect802 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 592.97,
    y: 847.53,
    width: 36,
    height: 36,
    transform: "translate(-433.07 685.53) rotate(-45)"
  })), _rect803 || (_rect803 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 643.88,
    y: 847.53,
    width: 36,
    height: 36,
    transform: "translate(-418.16 721.53) rotate(-45)"
  })), _rect804 || (_rect804 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 694.79,
    y: 847.53,
    width: 36,
    height: 36,
    transform: "translate(-403.25 757.53) rotate(-45)"
  })), _rect805 || (_rect805 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 745.7,
    y: 847.53,
    width: 36,
    height: 36,
    transform: "translate(-388.34 793.53) rotate(-45)"
  })), _rect806 || (_rect806 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 796.62,
    y: 847.54,
    width: 36,
    height: 36,
    transform: "translate(-373.43 829.53) rotate(-45)"
  })), _rect807 || (_rect807 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 847.53,
    y: 847.53,
    width: 36,
    height: 36,
    transform: "translate(-358.51 865.53) rotate(-45)"
  })), _rect808 || (_rect808 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 898.44,
    y: 847.53,
    width: 36,
    height: 36,
    transform: "translate(-343.6 901.53) rotate(-45)"
  })), _rect809 || (_rect809 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 949.35,
    y: 847.53,
    width: 36,
    height: 36,
    transform: "translate(-328.69 937.53) rotate(-45)"
  })), _rect810 || (_rect810 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 1000.26,
    y: 847.53,
    width: 36,
    height: 36,
    transform: "translate(-313.78 973.53) rotate(-45)"
  })), _rect811 || (_rect811 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 1051.17,
    y: 847.53,
    width: 36,
    height: 36,
    transform: "translate(-298.87 1009.53) rotate(-45)"
  })), _rect812 || (_rect812 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 542.06,
    y: 898.44,
    width: 36,
    height: 36,
    transform: "translate(-483.98 664.44) rotate(-45)"
  })), _rect813 || (_rect813 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 567.5,
    y: 923.9,
    width: 36,
    height: 36,
    transform: "translate(-494.53 689.88) rotate(-45)"
  })), _rect814 || (_rect814 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 618.41,
    y: 923.9,
    width: 36,
    height: 36,
    transform: "translate(-479.62 725.88) rotate(-45)"
  })), _rect815 || (_rect815 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 669.33,
    y: 923.89,
    width: 36,
    height: 36,
    transform: "translate(-464.7 761.89) rotate(-45)"
  })), _rect816 || (_rect816 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 720.25,
    y: 923.89,
    width: 36,
    height: 36,
    transform: "translate(-449.79 797.89) rotate(-45)"
  })), _rect817 || (_rect817 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 771.16,
    y: 923.89,
    width: 36,
    height: 36,
    transform: "translate(-434.88 833.89) rotate(-45)"
  })), _rect818 || (_rect818 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP5C",
    x: 822.07,
    y: 923.89,
    width: 36,
    height: 36,
    transform: "translate(-419.97 869.89) rotate(-45)"
  })), _rect819 || (_rect819 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 872.97,
    y: 923.9,
    width: 36,
    height: 36,
    transform: "translate(-405.06 905.88) rotate(-45)"
  })), _rect820 || (_rect820 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 923.88,
    y: 923.9,
    width: 36,
    height: 36,
    transform: "translate(-390.15 941.88) rotate(-45)"
  })), _rect821 || (_rect821 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 974.8,
    y: 923.89,
    width: 36,
    height: 36,
    transform: "translate(-375.23 977.89) rotate(-45)"
  })), _rect822 || (_rect822 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 1025.72,
    y: 923.89,
    width: 36,
    height: 36,
    transform: "translate(-360.32 1013.89) rotate(-45)"
  })), _rect823 || (_rect823 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 592.97,
    y: 898.44,
    width: 36,
    height: 36,
    transform: "translate(-469.07 700.44) rotate(-45)"
  })), _rect824 || (_rect824 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 643.88,
    y: 898.44,
    width: 36,
    height: 36,
    transform: "translate(-454.16 736.44) rotate(-45)"
  })), _rect825 || (_rect825 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 694.79,
    y: 898.44,
    width: 36,
    height: 36,
    transform: "translate(-439.25 772.44) rotate(-45)"
  })), _rect826 || (_rect826 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 745.7,
    y: 898.44,
    width: 36,
    height: 36,
    transform: "translate(-424.34 808.44) rotate(-45)"
  })), _rect827 || (_rect827 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP0C",
    x: 796.61,
    y: 898.44,
    width: 36,
    height: 36,
    transform: "translate(-409.42 844.44) rotate(-45)"
  })), _rect828 || (_rect828 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 847.53,
    y: 898.44,
    width: 36,
    height: 36,
    transform: "translate(-394.51 880.44) rotate(-45)"
  })), _rect829 || (_rect829 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP6C",
    x: 898.44,
    y: 898.44,
    width: 36,
    height: 36,
    transform: "translate(-379.6 916.44) rotate(-45)"
  })), _rect830 || (_rect830 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 949.35,
    y: 898.44,
    width: 36,
    height: 36,
    transform: "translate(-364.69 952.44) rotate(-45)"
  })), _rect831 || (_rect831 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 1000.26,
    y: 898.44,
    width: 36,
    height: 36,
    transform: "translate(-349.78 988.44) rotate(-45)"
  })), _rect832 || (_rect832 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 1051.17,
    y: 898.44,
    width: 36,
    height: 36,
    transform: "translate(-334.87 1024.44) rotate(-45)"
  })), _rect833 || (_rect833 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 542.06,
    y: 949.35,
    width: 36,
    height: 36,
    transform: "translate(-519.98 679.35) rotate(-45)"
  })), _rect834 || (_rect834 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 567.51,
    y: 974.81,
    width: 36,
    height: 36,
    transform: "translate(-530.53 704.81) rotate(-45)"
  })), _rect835 || (_rect835 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 618.43,
    y: 974.82,
    width: 36,
    height: 36,
    transform: "translate(-515.63 740.81) rotate(-45)"
  })), _rect836 || (_rect836 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 669.34,
    y: 974.82,
    width: 36,
    height: 36,
    transform: "translate(-500.71 776.81) rotate(-45)"
  })), _rect837 || (_rect837 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 720.25,
    y: 974.81,
    width: 36,
    height: 36,
    transform: "translate(-485.79 812.81) rotate(-45)"
  })), _rect838 || (_rect838 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 771.16,
    y: 974.81,
    width: 36,
    height: 36,
    transform: "translate(-470.88 848.81) rotate(-45)"
  })), _rect839 || (_rect839 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 822.07,
    y: 974.81,
    width: 36,
    height: 36,
    transform: "translate(-455.97 884.81) rotate(-45)"
  })), _rect840 || (_rect840 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 872.98,
    y: 974.81,
    width: 36,
    height: 36,
    transform: "translate(-441.06 920.81) rotate(-45)"
  })), _rect841 || (_rect841 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 923.9,
    y: 974.82,
    width: 36,
    height: 36,
    transform: "translate(-426.16 956.81) rotate(-45)"
  })), _rect842 || (_rect842 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 974.81,
    y: 974.82,
    width: 36,
    height: 36,
    transform: "translate(-411.24 992.81) rotate(-45)"
  })), _rect843 || (_rect843 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 1025.72,
    y: 974.81,
    width: 36,
    height: 36,
    transform: "translate(-396.32 1028.81) rotate(-45)"
  })), _rect844 || (_rect844 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 592.97,
    y: 949.35,
    width: 36,
    height: 36,
    transform: "translate(-505.07 715.35) rotate(-45)"
  })), _rect845 || (_rect845 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 643.88,
    y: 949.35,
    width: 36,
    height: 36,
    transform: "translate(-490.16 751.35) rotate(-45)"
  })), _rect846 || (_rect846 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 694.79,
    y: 949.35,
    width: 36,
    height: 36,
    transform: "translate(-475.25 787.35) rotate(-45)"
  })), _rect847 || (_rect847 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 745.7,
    y: 949.35,
    width: 36,
    height: 36,
    transform: "translate(-460.34 823.35) rotate(-45)"
  })), _rect848 || (_rect848 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP0C",
    x: 796.61,
    y: 949.35,
    width: 36,
    height: 36,
    transform: "translate(-445.42 859.35) rotate(-45)"
  })), _rect849 || (_rect849 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 847.53,
    y: 949.35,
    width: 36,
    height: 36,
    transform: "translate(-430.51 895.35) rotate(-45)"
  })), _rect850 || (_rect850 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 822.07,
    y: 923.89,
    width: 36,
    height: 36,
    transform: "translate(-419.97 869.89) rotate(-45)"
  })), _rect851 || (_rect851 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 898.44,
    y: 949.35,
    width: 36,
    height: 36,
    transform: "translate(-415.6 931.35) rotate(-45)"
  })), _rect852 || (_rect852 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 949.35,
    y: 949.35,
    width: 36,
    height: 36,
    transform: "translate(-400.69 967.35) rotate(-45)"
  })), _rect853 || (_rect853 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 1000.26,
    y: 949.35,
    width: 36,
    height: 36,
    transform: "translate(-385.78 1003.35) rotate(-45)"
  })), _rect854 || (_rect854 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 1051.17,
    y: 949.35,
    width: 36,
    height: 36,
    transform: "translate(-370.87 1039.35) rotate(-45)"
  })), _rect855 || (_rect855 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 542.06,
    y: 1000.26,
    width: 36,
    height: 36,
    transform: "translate(-555.98 694.26) rotate(-45)"
  })), _rect856 || (_rect856 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 567.51,
    y: 1025.72,
    width: 36,
    height: 36,
    transform: "translate(-566.53 719.72) rotate(-45)"
  })), _rect857 || (_rect857 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 618.42,
    y: 1025.72,
    width: 36,
    height: 36,
    transform: "translate(-551.62 755.72) rotate(-45)"
  })), _rect858 || (_rect858 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 669.34,
    y: 1025.73,
    width: 36,
    height: 36,
    transform: "translate(-536.71 791.72) rotate(-45)"
  })), _rect859 || (_rect859 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 720.25,
    y: 1025.72,
    width: 36,
    height: 36,
    transform: "translate(-521.79 827.72) rotate(-45)"
  })), _rect860 || (_rect860 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 771.16,
    y: 1025.72,
    width: 36,
    height: 36,
    transform: "translate(-506.88 863.72) rotate(-45)"
  })), _rect861 || (_rect861 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 822.07,
    y: 1025.72,
    width: 36,
    height: 36,
    transform: "translate(-491.97 899.72) rotate(-45)"
  })), _rect862 || (_rect862 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 872.98,
    y: 1025.72,
    width: 36,
    height: 36,
    transform: "translate(-477.06 935.72) rotate(-45)"
  })), _rect863 || (_rect863 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 923.89,
    y: 1025.72,
    width: 36,
    height: 36,
    transform: "translate(-462.15 971.72) rotate(-45)"
  })), _rect864 || (_rect864 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 974.81,
    y: 1025.73,
    width: 36,
    height: 36,
    transform: "translate(-447.24 1007.72) rotate(-45)"
  })), _rect865 || (_rect865 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 1025.72,
    y: 1025.72,
    width: 36,
    height: 36,
    transform: "translate(-432.32 1043.72) rotate(-45)"
  })), _rect866 || (_rect866 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 592.97,
    y: 1000.26,
    width: 36,
    height: 36,
    transform: "translate(-541.07 730.26) rotate(-45)"
  })), _rect867 || (_rect867 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 643.88,
    y: 1000.26,
    width: 36,
    height: 36,
    transform: "translate(-526.16 766.26) rotate(-45)"
  })), _rect868 || (_rect868 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 694.79,
    y: 1000.26,
    width: 36,
    height: 36,
    transform: "translate(-511.25 802.26) rotate(-45)"
  })), _rect869 || (_rect869 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 745.7,
    y: 1000.26,
    width: 36,
    height: 36,
    transform: "translate(-496.34 838.26) rotate(-45)"
  })), _rect870 || (_rect870 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP0C",
    x: 796.6,
    y: 1000.26,
    width: 36,
    height: 36,
    transform: "translate(-481.43 874.25) rotate(-45)"
  })), _rect871 || (_rect871 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 847.53,
    y: 1000.26,
    width: 36,
    height: 36,
    transform: "translate(-466.51 910.26) rotate(-45)"
  })), _rect872 || (_rect872 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 898.44,
    y: 1000.26,
    width: 36,
    height: 36,
    transform: "translate(-451.6 946.26) rotate(-45)"
  })), _rect873 || (_rect873 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 949.35,
    y: 1000.26,
    width: 36,
    height: 36,
    transform: "translate(-436.69 982.26) rotate(-45)"
  })), _rect874 || (_rect874 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP2C",
    x: 1000.26,
    y: 1000.26,
    width: 36,
    height: 36,
    transform: "translate(-421.78 1018.26) rotate(-45)"
  })), _rect875 || (_rect875 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 1051.17,
    y: 1000.26,
    width: 36,
    height: 36,
    transform: "translate(-406.87 1054.26) rotate(-45)"
  })), _rect876 || (_rect876 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 542.06,
    y: 1051.17,
    width: 36,
    height: 36,
    transform: "translate(-591.98 709.17) rotate(-45)"
  })), _rect877 || (_rect877 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 592.97,
    y: 1051.17,
    width: 36,
    height: 36,
    transform: "translate(-577.07 745.17) rotate(-45)"
  })), _rect878 || (_rect878 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 643.88,
    y: 1051.17,
    width: 36,
    height: 36,
    transform: "translate(-562.16 781.17) rotate(-45)"
  })), _rect879 || (_rect879 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 694.79,
    y: 1051.17,
    width: 36,
    height: 36,
    transform: "translate(-547.25 817.17) rotate(-45)"
  })), _rect880 || (_rect880 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 745.69,
    y: 1051.18,
    width: 36,
    height: 36,
    transform: "translate(-532.34 853.16) rotate(-45)"
  })), _rect881 || (_rect881 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 796.61,
    y: 1051.17,
    width: 36,
    height: 36,
    transform: "translate(-517.42 889.17) rotate(-45)"
  })), _rect882 || (_rect882 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 847.53,
    y: 1051.17,
    width: 36,
    height: 36,
    transform: "translate(-502.51 925.17) rotate(-45)"
  })), _rect883 || (_rect883 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 898.44,
    y: 1051.17,
    width: 36,
    height: 36,
    transform: "translate(-487.6 961.17) rotate(-45)"
  })), _rect884 || (_rect884 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 949.35,
    y: 1051.17,
    width: 36,
    height: 36,
    transform: "translate(-472.69 997.17) rotate(-45)"
  })), _rect885 || (_rect885 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 1000.26,
    y: 1051.17,
    width: 36,
    height: 36,
    transform: "translate(-457.78 1033.17) rotate(-45)"
  })), _rect886 || (_rect886 = /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "firstP1C",
    x: 1051.16,
    y: 1051.18,
    width: 36,
    height: 36,
    transform: "translate(-442.87 1069.16) rotate(-45)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstPClear);
export default __webpack_public_path__ + "static/media/FirstP_Clear.bcc535d7ec54b36f6a00aed4a6ff7503.svg";
export { ForwardRef as ReactComponent };